import React, { useEffect, useState } from "react";
import Helper from "../Helper";
import { APPLICATION_JSON, DEFAULT_IMAGE_140, DEFAULT_IMAGE_220, DEFAULT_IMAGE_400 } from "../../middleware/types";
import './Description.css'
import { useLocation, Link } from "react-router-dom/cjs/react-router-dom.min";
import useStateRef from "react-usestateref";
import BreadCrumbsContainer from "../BreadCrumbs/BreadCrumbsContainer";
import AddToCartSuccessModal from "../PlpSection/AddToCartSuccessModal";
import AddShoppingListModal from "../PlpSection/AddShoppingListModal";
import CbLoginModal from "../CbLogin/CbLoginModal";
import ReviewSection from "./ReviewSection";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileDetailsAction } from "../../middleware/updateProfileDetailsAction";
import RecommendedAccessories from "./RecommendedAccessories";
import CbCarouselHorizontal from "../CbCarouselVertical/CbCarouselHorizontal";
import ProductQuickViewModal from "../PlpSection/ProductQuickViewModal";
import Question from "./Question";
import YouMayAlso from "./YouMayAlso";
import ReactPlayerLoader from "@brightcove/react-player-loader";
import Zoom from 'react-img-hover-zoom'
import P65Warning from "./P65Warning";
import ProductModal from "./ProductModal";
import TeacherResourcesCarousel from "./TeacherResourcesCarousel";
import { object } from "prop-types";
import IncludedQuickView from "./IncludedQuickView";
import AddShoppingListModalTwo from "../PlpSection/AddShoppingListModalTwo";

const ProductDetailsContainer = ({ containerObject, templateName, contentId, dataZone }) => {

	const [productDetailsContent, setProductDetailsContent] = useState()
	const [pdfUrl, setPdfUrl] = useState()
	const [isLoading, setIsLoading] = useState(false);
	const [count, setCount] = useState(1);
	const [productcount, setproductCount, productcountref] = useStateRef({});
	const [triggerModal, setTriggerModal, triggerModalRef] = useStateRef(false);
	const [triggerAddToListModal, setAddToListModal, triggerAddToListModalRef] = useStateRef(false);
	const [productId, setProductId, productIdRef] = useStateRef();
	const [wishlistQty, setWishlistQty, wishlistQtyRef] = useStateRef(1);
	const location = useLocation()
	const [prodId, setProdId, prodIdRef] = useStateRef()
	const [domainName, setdomainName, domainNameRef] = useStateRef(containerObject.domainName ? containerObject.domainName : "")
	const [select, setSelect, selectRef] = useStateRef({})
	const [selectKey, setSelectKey, selectKeyRef] = useStateRef()
	const [selectValue, setselectValue, selectValueRef] = useStateRef()
	const [selectSkuResult, setSelectSkuResult, selectSkuResultRef] = useStateRef()
	const [showUnavaiable, setShowUnavaiable, ShowUnavaiableRef] = useStateRef()
	const [available, setavaiable, avaiableRef] = useStateRef()
	const [backOrder, setbackOrder, backOrderRef] = useStateRef() 
	const [showMore, setShowMore, showMoreRef] = useStateRef()
	const [includedItemLength, setIncludedItemLength, includedItemLengthRef] = useStateRef()
	const [notIncludedItemLength, setNotIncludedItemLength, notIncludedItemLengthRef] = useStateRef()
	const [featuresLength, setFeaturesLength, featuresLengthRef] = useStateRef()
	const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
	const [productSpec, setProductSpec, productSpecRef] = useStateRef()
	const [avalClass, setAvalClass, avalClassRef] = useStateRef()
	const [productDetailsObj, setProductDetailsObj, productDetailsObjRef] = useStateRef()
	const [solrValue, setSolrValue, solrValueRef] = useStateRef("")
	const [relatedResourcesObj, setRelatedResourcesObj, relatedResourcesObjRef] = useStateRef()
	const [productTabsDescription, setProductTabsDescription, ProductTabsDescriptionRef] = useStateRef()
	const [productTabspropsMessage, setProductTabspropsMessage, ProductTabspropsMessageRef] = useStateRef()
	const [productSpecficationcDetails, setProductSpecficationDetails, productSpecficationDetailsRef] = useStateRef()
	const [siteSpecDetails, setSiteSpecDetails, siteSpecDetailsRef] = useStateRef()
	const [productName, setProductName, productNameRef] = useStateRef()
	const dispatch = useDispatch();
	const [productImage, setProductImage, productImageRef] = useStateRef();
	const [selectedOneKey, setSelectedOneKey, selectedOneKeyRef] = useStateRef();
	const [selectedOneValue, setSelectedOneValue, selectedOneValueRef] = useStateRef();
	const [isDlproduct, setIsDlproduct, isDlproductRef] = useStateRef();
	const [productType, setProductType, productTypeRef] = useStateRef();
	const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef("")
	const [warning, setWarning, warningRef] = useStateRef()
	const [releatedOrder, setReleatedOrder, releatedOrderRef] = useStateRef(containerObject.resourcesOrderList ? containerObject.resourcesOrderList : "")
	const [jsonId, setjsonId, jsonIdRef] = useStateRef()
	const [staticStickyNavSec, setStaticStickyNavSec, staticStickyNavSecRef] = useStateRef()
	const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
	const onFailure = () => console.log("player error");
	const onSuccess = () => console.log("player success");
	const [imageZoom, setImageZoom, imageZoomRef] = useStateRef(containerObject.imageZoom ? containerObject.imageZoom : "N")
	const [includeQuick, setIncludeQuickRef, includeQuickRef] = useStateRef()
	const [includeQuickId, setIncludeQuickRefId, includeQuickRefId] = useStateRef()
	const [whatsIncludedList, setWhatsIncludedList, whatsIncludedListRef] = useStateRef({});
	const [whatsNotIncludedList, setWhatsNotIncludedList, whatsNotIncludedListRef] = useStateRef({});
	const [hoverProductId, setHoverProductId, hoverProductIdRef] = useStateRef('');
	const [actionToggle, setActionToggle, actionToggleRef] = useStateRef(false);
	const [backOrderQty, setBackOrderQty, backOrderQtyRef] = useStateRef(0);
	var pathName = location.pathname
	var pathList = pathName.split("/")
	var ItemLength = 4;

	function handleVideoPause(e) {
		setTimeout(() => {
			var getvideosList = document.querySelectorAll(".vjs-play-control.vjs-playing");
			if (getvideosList) {
				for (var i = 0; i < getvideosList.length; i++) {
					getvideosList[i].click()
				}
			}
		}, 100);

	}

	function handleFormEmpty(e) {
		if (document.querySelector('#quickViewModal')) {
			document.querySelector('#quickViewModal').addEventListener('hidden.bs.modal', function (e) {
				if (document.getElementById("addToCart")) {
					document.getElementById("addToCart").reset();
				}
			})
		}
	}
	function handleShowThumbNailProduct(imageLength, videoListLength) {
		let length = imageLength + videoListLength;
		return length;
	}



	function handleFamilyVarientDefaultQty() {
		let qty = 1;
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyItem && containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList && containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList.map((oneItems) => {

			setproductCount({ ...productcountref.current, [oneItems.skuId]: qty })
		})
	}

	function handleWarning(head, description, icon) {

		let map = {
			head: head,
			description: description,
			icon: icon
		}
		setWarning(map)
		document.getElementById("warning65").click()


	}


	function handleChangeCount(event) {
		let value = event.target.value;
		let qty = parseInt(value);
		setCount(qty)
	}

	function handleChangeCountForVarient(event) {
		let value = event.target.value;
		let qty = parseInt(value)
		let eventId = event.target.id;
		setproductCount({ ...productcountref.current, [eventId]: qty })


	}

	function replaceImage(event) {

		event.target.src = DEFAULT_IMAGE_140;

	}


	function handleReplaceLargeNormalImage(event) {

		event.target.src = DEFAULT_IMAGE_400;

	}

	function replaceImageDLProduct(event) {

		event.target.src = DEFAULT_IMAGE_400;

	}

	function handleReplaceLargeImage(event) {
		var id = event.target.id;
		event.target.src = DEFAULT_IMAGE_400;
		var zoomImageId = "#zoomImage_".concat(id);

		var replace = document.querySelector(zoomImageId);
		if (replace) {
			let largeImage = replace.getAttribute("imageurl")
			const img = document.createElement('img');
			img.src = largeImage;

			img.onload = () => {
				// Image loaded successfully
				replace.children[0].removeAttribute('srcSet');
				replace.setAttribute("imageurl", largeImage);
			};

			img.onerror = () => {
				// Image failed to load
				replace.setAttribute("imageurl", DEFAULT_IMAGE_400);
			};
		}
	}

	function handleReplaceLargeImageForFamily(event) {
		var id = event.target.id;
		event.target.src = DEFAULT_IMAGE_220;
		var zoomImageId = "#zoomImage_".concat(id);

		var replace = document.querySelector(zoomImageId);
		if (replace) {
			let largeImage = replace.getAttribute("imageurl")
			const img = document.createElement('img');
			img.src = largeImage;

			img.onload = () => {
				// Image loaded successfully
				replace.setAttribute("imageurl", largeImage);
			};

			img.onerror = () => {
				// Image failed to load
				replace.setAttribute("imageurl", DEFAULT_IMAGE_400);
			};

		}

	}

	function handleSiteSpecUserAction() {
		let page = {};
		let productType;
		var productMap = {}
		var categoryList;
		var categoryListSample = []
		var productList = [];
		if (containerObject.breadCrumbDataLayer) {
			let breadDL = containerObject.breadCrumbDataLayer;
			const categoryList1 = [breadDL["dataLayer_obj.productSubCat1"] && breadDL["dataLayer_obj.productSubCat1"], breadDL["dataLayer_obj.productSubCat2"] && breadDL["dataLayer_obj.productSubCat2"], breadDL["dataLayer_obj.productSubCat3"] && breadDL["dataLayer_obj.productSubCat3"], breadDL["dataLayer_obj.productSubCat4"] && breadDL["dataLayer_obj.productSubCat4"]];

			categoryList = categoryList1;
			Object.entries(breadDL).map(([key, value], keyIndex) => {
				categoryListSample.push(value)
			})
		}
		if (productTypeRef.current == "CBS Product") {
			let isproductGrouping = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isproductGrouping;
			productType = "product"
			let productId = selectSkuResultRef.current ? selectSkuResultRef.current : prodIdRef.current.includes("FAM_") ? prodIdRef.current.replace("FAM_", "") : prodIdRef.current;

			const productMapDuplicate = {
				"productId": productId,
				"category": categoryList
			}
			productMap = productMapDuplicate;
			productList.push(productMap)
			const pageAttr = {
				"type": productType,
				"products": productList
			}
			page = pageAttr;

		} else if (productTypeRef.current == "CBS Family") {
			productType = "product"
			productSpecRef.current.map((oneProduct, index) => {

				const productMapDuplicate = {
					"productId": oneProduct,
					"category": categoryList
				}
				productMap = productMapDuplicate;
				if(index < 27){
					productList.push(productMap)
				}
				
			})
			const pageAttr = {
				"type": productType,
				"products": productList
			}
			page = pageAttr;

		} else {
			productSpecRef?.current && productSpecRef?.current.map((oneProduct, index) => {
				productType = "resource"
				const productMapDuplicate = {
					"resourceId": oneProduct,
					"category": categoryList
				}
				productMap = productMapDuplicate;
				productList.push(productMap)
			})
			const pageAttr = {
				"type": productType,
				"resources": productList
			}
			page = pageAttr;

		}


		const PDP_payload = {
			"type": "page-view",
			"page": page
		}

		window.ssRecsInfo = window.ssRecsInfo || {}
		 
		window.ssRecsInfo = PDP_payload
		console.log("sitespect-user-action in pageview one");
		
		window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': PDP_payload }))
		console.log("sitespect-user-action in pageview two"); 
	}


	function handleProductImage(image) {
		setProductImage(image)
		setTimeout(() => {
			document.getElementById("productImageModal").click();
		}, 1000);

	}

	function handleVideo() {

		const head = document.querySelector("#videoUrl");
		console.log("handleVideo head", head);
		const scriptTags = head.getElementsByTagName('script');
		if (scriptTags) {
			[...scriptTags].forEach(tag => tag.remove());
		}
		// let playerUrlList = [`script[src*="players.brightcove"]`]
		// console.log("handleVideo playerUrlList", playerUrlList);
		// console.log("handleVideo playerUrlList", playerUrlList.length);
		// for (let i = 1; i < playerUrlList.length; i++) {
		// console.log("handleVideo playerurl query",playerUrlList[i])
		let playerurl = document.querySelectorAll(`script[src*="players.brightcove"]`)

		for (let i = 0; i < playerurl.length; i++) {
			console.log("handleVideo playerurl", playerurl[i]);
			const script = document.createElement("script");
			if (playerurl[i]) {
				var url = playerurl[i].getAttribute("src");
				console.log("handleVideo url", url);
				if (url) {
					script.setAttribute("src", url);
					head.appendChild(script);
				}
			}
		}


	}
	function htmlRawContainerAccordian() {
		setTimeout(() => {


			const expand = document.querySelectorAll(".expand h2");
			// const scriptTag = document.querySelectorAll("div[data-experience] script");
			// console.log("htmlRawContainerAccordian scriptTag",scriptTag);
			handleVideo()
			teacherResProductScroll()
			if (expand) {
				const expandContent = document.querySelectorAll(".expand .expand-content");
				for (let i = 0; i < expand.length; i++) {
					expand[i].addEventListener("click", function () {
						let expandTag = expand[i];
						let expandContentTag = expandContent[i]
						if (expandTag.classList.contains("ui-state-active")) {
							expandTag.classList.remove("ui-state-active")
							expandContentTag.classList.remove("d-block")
						} else {
							expandTag.classList.add("ui-state-active")
							expandContentTag.classList.add("d-block")
						}
					});
				}
			}

			// here we handle hubspot from for pdp page
			const hsClass = document.querySelector(".ngssebook-copy");

			if (hsClass) {
				var portalId = hsClass.getAttribute("portalId");
				var formId = hsClass.getAttribute("formId");
				var region = hsClass.getAttribute("region");

				var hubSpotUrl = `/hubSpotForm?portalId=${portalId ? portalId : "44059706"}&formId=${formId ? formId : "369d68d2-7993-4ddc-91ad-46914ae7f1d7"}&region=${region ? region : "nal"}`


				hsClass.innerHTML = ` <iframe className="pdpHubspotForm" scrolling="no" style="width: 100%;height: 1018px;"  src=${hubSpotUrl} />`;

			}

		}, 100);

	}
	function teacherResProductScroll() {
		let scrollList = document.querySelectorAll("a.smoothscroll");
		console.log("scrollList", scrollList);
		if (scrollList) {
			for (let i = 0; i < scrollList.length; i++) {
				let targetId = scrollList[i].getAttribute("href")
				scrollList[i].setAttribute("href", "#");
				scrollList[i].setAttribute("targetid", targetId);
				scrollList[i].removeEventListener("click", function () { }, true);
				scrollList[i].addEventListener("click", function (event) {
					event.preventDefault()
					let oneScroll = scrollList[i];
					console.log("oneScroll click", oneScroll);
					let target = oneScroll.getAttribute("targetid")
					console.log("oneScroll target", target);
					if (target) {
						let targetId = document.querySelector(target);
						console.log("oneScroll targetId", targetId);
						if (targetId) {
							let targetoffSetTop = targetId.offsetTop;
							console.log("oneScroll targetoffSetTop", targetoffSetTop);
							targetId.scrollIntoView({ behavior: 'smooth' })
						}
					}


				})
			}
		}

	}


	function dlProduct() {
		setIsDlproduct(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isDLProduct);
	}
	function prodType() {
		setProductType(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.prodType ? containerObject.atgResponse.response.response.familyProduct.galleryJson.prodType :
			containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.prodType ? containerObject.atgResponse.response.response.standardResult.galleryPageResult.prodType :
				containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.galleryJsonResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.galleryJsonResult.prodType ? containerObject.atgResponse.response.response.familyVariyantProductDetails.galleryJsonResult.prodType : "")

	}


	function handleRetailPrice(data, type) {

		let regSalePrice = data && data.regSalePrice && data.regSalePrice;
		let retailPrice = data && data.retailPrice && data.retailPrice;
		let regBasePrice = data && data.regBasePrice && data.regBasePrice;
		let profileType = type && type;
		if (regBasePrice) {
			if (regBasePrice.includes("$")) {
				regBasePrice = regBasePrice.replace("$", "");
			}
			if (regBasePrice.includes(",")) {
				regBasePrice = regBasePrice.replace(",", "");
			}
		}

		if (retailPrice) {
			if (retailPrice.includes("$")) {
				retailPrice = retailPrice.replace("$", "");
			}
			if (retailPrice.includes(",")) {
				retailPrice = retailPrice.replace(",", "");
			}
		}

		if (regBasePrice === retailPrice) {
			return "equal"
		} else {
			return "notEqual"
		}
	}







	const iconObjectMap = {

		"exclamation-triangle-icon": <i><img alt="exclamation triangle icon" loading="lazy" src={`${domainNameRef.current}/images/icons/exclamation-triangle-icon.svg`} /></i>,
		"document-icon": <i><img alt="document icon" loading="lazy" src={`${domainNameRef.current}/images/icons/document-icon.svg`} /></i>,
		"magnify-icon": <i><img alt="magnify icon" loading="lazy" src={`${domainNameRef.current}/images/icons/magnify-icon.svg`} /></i>,
		"video-play-icon": <i><img alt="magnify icon" loading="lazy" src={`${domainNameRef.current}/images/icons/video-play-icon.svg`} /></i>,
		"life-care-icon": <i><img alt="life care icon" loading="lazy" src={`${domainNameRef.current}/images/icons/life-care-icon.svg`} /></i>,
	}



	function handleSetProductId() {
		if (containerObject.atgResponse.result == "success") {
			setProductId(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : "")
			setProdId(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : "")
		}

	}

	function handleEcommerceDatalayer() {
		console.log("log in pdp handleEcommerceDatalayer");
		setTimeout(() => {
			if (productTypeRef.current) {
				var categoryList = []

				if (containerObject.breadCrumbDataLayer) {
					let breadDL = containerObject.breadCrumbDataLayer;
					const categoryList1 = [breadDL["dataLayer_obj.productSubCat1"] && breadDL["dataLayer_obj.productSubCat1"], breadDL["dataLayer_obj.productSubCat2"] && breadDL["dataLayer_obj.productSubCat2"], breadDL["dataLayer_obj.productSubCat3"] && breadDL["dataLayer_obj.productSubCat3"], breadDL["dataLayer_obj.productSubCat4"] && breadDL["dataLayer_obj.productSubCat4"]];
					categoryList = categoryList1;
				}
				var skuName = [];
				var skuList = [];
				var container = containerObject?.atgResponse?.response?.response
				if (container && container.familyProduct && container.familyProduct.familyItem && container.familyProduct.familyItem.familyProductsList) {

					var familyList = container.familyProduct.familyItem.familyProductsList ? container.familyProduct.familyItem.familyProductsList : ""
					familyList && familyList.map((oneSku) => {
						if (skuList.includes(oneSku?.id)) {

						} else {
							skuList.push(oneSku?.id)
							skuName.push(oneSku?.displayName)
						}
					})



				}

				else if (container && container.product != null) {
					var productId = container.product;
					productId = productId.includes("FAM_") ? productId.replace("FAM_", "") : productId;
					skuList.push(productId)
					skuName.push(container.displayName)

				}
				if (skuList.length >= 1) {
					handleDataOrder(skuList, skuName, categoryList)
				}
			}
		}, 5000);

	}

	function handleDataOrder(idList, nameList, categoryList, itemList) {
		var items = [];

		let item_list_name = productTypeRef.current && productTypeRef.current == "CBS Product" && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isproductGrouping == false ? "Product Detail - Individual" : "";
		let dataLayerObject = containerObject?.atgResponse?.response?.response?.dataLayer;
		let item_list_id = dataLayerObject?.productDetail?.page_type ?? ""

		var priceArrCB = [];
		var itemBrand = "";
		var productPriceList = [];
		if (productTypeRef?.current == "CBS Product" && containerObject?.atgResponse?.response?.response?.isproductGrouping == true) {
			itemBrand = "Carolina";
			let varientNameList = [];
			varientNameList.push(containerObject?.atgResponse?.response?.response?.familyVariyantDisplayName)
			nameList = varientNameList;
		}

		idList.map((oneid, index) => {
			var priceArrCBFam;
			let queryId = `#ecommPrice_${oneid}`
			let idList = document.querySelectorAll(queryId);

			if (idList) {
				for (let i = 0; i < idList.length; i++) {
					let onePrice = idList[i].innerHTML;
					if (productTypeRef.current && productTypeRef.current == "CBS Product") {
						if (onePrice) {
							priceArrCB.push(onePrice.replace("$", ""))
						}
					} else {
						if (onePrice) {
							if (priceArrCBFam) {
								priceArrCBFam = priceArrCBFam.concat(",", onePrice.replace("$", ""))
							} else {
								priceArrCBFam = onePrice.replace("$", "")
							}

						}
					}
					if (productTypeRef.current && productTypeRef.current == "CBS Product") {
						if (onePrice) {
							productPriceList.push(onePrice.replace("$", ""))
						}
					}

				}

			}






			items.push({
				'item_id': oneid,
				'item_name': nameList[index],
				'affiliation': '',
				'coupon': '',
				'currency': 'USD',
				'discount': '',
				'index': 0,
				'item_brand': itemBrand,
				'item_category': categoryList[0] ? [categoryList[0]] : categoryList[0],
				'item_category2': categoryList[1] ? [categoryList[1]] : categoryList[1],
				'item_category3': categoryList[2] ? [categoryList[2]] : categoryList[2],
				'item_category4': categoryList[3] ? [categoryList[3]] : categoryList[3],
				'item_category5': '',
				'item_list_id': '',
				'item_list_name': '',
				'item_variant': selectSkuResultRef.current ? selectSkuResultRef.current : '',
				'location_id': '',
				'price': productTypeRef.current && productTypeRef.current == "CBS Product" ? priceArrCB : priceArrCBFam,
				'quantity': 1
			})
		})
		let ecommFamilyPriceList = document.querySelectorAll("#ecommFamilyPrice");
		if (ecommFamilyPriceList) {

			for (let i = 0; i < ecommFamilyPriceList.length; i++) {
				let onePriceValue = ecommFamilyPriceList[i].innerHTML;
				if (onePriceValue && onePriceValue.includes("-")) {
					let priceSplit = onePriceValue.split("-");
					priceSplit.map((onePriceValue) => {
						let price = onePriceValue.trim();
						if (price.includes("$")) {
							productPriceList.push(price.replace("$", ""))
						}
					})
				}
			}
		}
		let ecommerce = {
			"items": items
		}
		let ecommerceData = {
			"ecommerce": ecommerce,
			"event": "view_item"
		}
		let ecommerceEmptyData = {
			"ecommerce": null
		}
		var priceMap = {
			"productPrice": productPriceList
		}
		var priceMapEmptyList = {
			"productPrice": null
		}
		window.dataLayer = window.dataLayer || []
		if (window.dataLayer.length > 0) {
			if (productPriceList.length > 0) {
				window.dataLayer.push(priceMapEmptyList)
				window.dataLayer.push(priceMap)
			}
			window.dataLayer.push(ecommerceEmptyData)
			window.dataLayer.push(ecommerceData)

		}




	}



	useEffect(() => {
		//console.log("log in pdp page loader", loaderStatus);
		//console.log("log in pdp page container", containerObject);
		if (loaderStatus == true) {
			console.log("log in pdp page loader true");
		} else {
			console.log("log in pdp page loader false");
			setScreenWidth(screen.width)

			handleFamilyVarientDefaultQty()
			handleFormEmpty();
			// handleCloseQuickView()
			window.addEventListener('scroll', function () {
				// here we handle the sticky header for product
				var stickyNav = document.getElementById("prod-sticky-nav");
				var stickyNavSec = window.innerWidth > 767 ? document.getElementById("prod-sticky-nav") : document.getElementById("pdp-nav");
				var stickyNavTop = stickyNavSec?.offsetTop;
				if (!staticStickyNavSecRef.current) {
					setStaticStickyNavSec(stickyNavTop)
				}
				var sitckyNavHeight = stickyNavSec?.offsetHeight + 1;
				var body = document.getElementById('body')?.offsetTop - 10;
				if (body != null && stickyNavSec) {
					if (window.scrollY > stickyNavTop) {
						if (window.innerWidth < 810) {
							if (staticStickyNavSecRef.current < window.scrollY) {
								stickyNav.classList.add('sticky-nav');
								stickyNav.classList.add('d-lg-inline-flex');
							} else {
								stickyNav.classList.remove('sticky-nav');
								stickyNav.classList.remove('d-lg-inline-flex');
							}
						} else {
							stickyNav.classList.add('sticky-nav');
							stickyNav.classList.add('d-lg-inline-flex');
						}
					} else {
						stickyNav.classList.remove('sticky-nav');
						stickyNav.classList.remove('d-lg-inline-flex');
					}
				}
			});
			prodType()
			handleBazaarVoice()
			setProductDetailsContent(containerObject && containerObject.atgResponse && containerObject.atgResponse.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response ? containerObject.atgResponse.response.response : "")
			var pdfurl = containerObject && containerObject.atgResponse && containerObject.atgResponse.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailPDF && containerObject.atgResponse.response.response.teacherResource.detailPDF.pdfPath ? containerObject.atgResponse.response.response.teacherResource.detailPDF.pdfPath : ""
			handleSetProductId()
			dlProduct()

			selectedSku()
			handleDisplayPrice()
			defaultSelectedSku()
			handleShowMoreLength()
			handleProductSpec()
			relatedResources()
			setTimeout(() => {
				handleFamilyTabsRelatedResources()
			}, 100);
			
			setPdfUrl(containerObject && containerObject.atgResponse && containerObject.atgResponse.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailPDF ? containerObject.atgResponse.response.response.teacherResource.detailPDF.pdfPath : "")
			
			handleReviewHideorShow()
			htmlRawContainerAccordian()
			handleZoomImage()
			console.log("log in pdp dataLayer");
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				if (productTypeRef.current && productTypeRef.current == "CBS Family") {
					let familyEvent = {
						"event": "productDetailFamily"
					}
					window.dataLayer.push(familyEvent)
				}
			}

			if (containerObject?.atgResponse?.response?.response?.dataLayer) {
				window.dataLayer = window.dataLayer || []
				if (window.dataLayer.length >= 0) {
					let dataLayerObject = containerObject?.atgResponse?.response?.response?.dataLayer;
					let productDetail = dataLayerObject?.productDetail
					let dataLayerJson = dataLayerObject?.dataLayerObject?.dataLayerJson
					var productPrice = dataLayerObject?.productPrice
					let rtsProductDataLayerJson = dataLayerObject?.rtsProductDataLayerJson

					if (productTypeRef.current && productDetail && Object.keys(productDetail).length != 0) {
						let productId = productDetail?.productId
						if (productTypeRef.current && productTypeRef.current == "CBS Family") {
							productId = containerObject?.atgResponse?.response?.response?.product
						}
						let productDetailMap = {
							pageType: productDetail?.page_type,
							productId: [productDetail?.productId],
							productImageUrl: [domainNameRef.current.concat(productDetail?.productImageUrl)],
							productName: [productDetail?.productName],
							productUrl: [domainNameRef.current.concat(productDetail?.productUrl)]
						}
						window.dataLayer.push(productDetailMap)
					}
					if (dataLayerJson && Object.keys(dataLayerJson).length != 0) {
						window.dataLayer.push(dataLayerJson)
					}

					// if (productTypeRef.current && productPrice && Object.keys(productPrice).length != 0) {
					// 	let productPriceList = [];
					// 	for (let i = 0; i < productPrice.length; i++) {
					// 		let onePrice = productPrice[i].toString().includes("$") ? productPrice[i].toString().replace("$", "") : productPrice[i].toString();
					// 		productPriceList.push(onePrice.toString())
					// 	}
					// 	let priceMap = {
					// 		"productPrice": productPriceList
					// 	}
					// 	window.dataLayer.push(priceMap)
					// }
					if (rtsProductDataLayerJson) {
						window.dataLayer.push(rtsProductDataLayerJson)
					}
				}
			}
			if (containerObject.breadCrumbDataLayer && containerObject.breadCrumbDataLayer) {
				window.dataLayer_obj = window.dataLayer_obj || []
				if (window.dataLayer_obj.length <= 0) {
					window.dataLayer_obj.push(containerObject.breadCrumbDataLayer)
				}
			}

			handleEcommerceDatalayer()
			handlePdfDataLayer()
			handleHtmlAndVideoDataLayer()
			handlePdpDataLayer()

			const titleElement = document.querySelector('title')
			if (containerObject.currentProductName) {
				titleElement.innerHTML = containerObject.currentProductName + " | Carolina Biological Supply"
			} else {
				titleElement.innerHTML = "Carolina Biological Supply"
			}
            setBackOrderQty(containerObject
                            && containerObject.atgResponse
                            && containerObject.atgResponse.response
                            && containerObject.atgResponse.response.response
                            && containerObject.atgResponse.response.response.standardResult
                            && containerObject.atgResponse.response.response.standardResult.pdpOrderResult
                            && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp
                            && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.backOrderQty ? containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.backOrderQty : 0);
		}
	}, [])

	
	function handleProductSpec() {
		console.log("siteSpec in pdp");
		var skuList = [];
		var container = containerObject.atgResponse.response.response
		if (container && container.familyProduct && container.familyProduct.familyItem && container.familyProduct.familyItem.familyProductsList) {

			var productId = container.familyProduct.familyItem.productId
			productId = productId.includes("FAM_") ? productId.replace("FAM_", "") : productId;
			skuList.push(productId)
			var familyList = container.familyProduct.familyItem.familyProductsList ? container.familyProduct.familyItem.familyProductsList : ""
			familyList && familyList.map((oneSku) => {
				if (skuList.includes(oneSku.id)) {

				} else {
					skuList.push(oneSku.id)
				}
			})
			setProductSpec(skuList)

		}

		else if (container && container.product != null) {
			var productId = container.product;
			productId = productId.includes("FAM_") ? productId.replace("FAM_", "") : productId;
			skuList.push(productId)
			setProductSpec(skuList)
		}
		// sitespec call
		const rule = []
		const valueMapOne = {
			var: "cbsParentCategory"
		}
		const valueArrayOne = [];
		valueArrayOne.push(valueMapOne)
		const ruleOne = {
			name: "cbsParentCategory",
			bias: 11,
			values: valueArrayOne
		}
		const valueArrayTwo = [];
		valueArrayTwo.push("20501")
		const ruleTwo = {
			name: "cbsParentCategory",
			bias: 0,
			values: valueArrayTwo
		}
		rule.push(ruleOne)
		rule.push(ruleTwo)

		const map = {
			actionSkus: productSpecRef.current,
			algorithm: "people-also-like",
			itemSet: productSpecRef.current,
			num: 10,
			rules: rule
		}
		const inputMap = {
			spectMap: map
		}
		siteSpec(inputMap)


	}

	function handleFamilyTabsRelatedResources() {
		let familyTabsDescription;
		let showRelatedResources = true;
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean?.skus?.map((oneSku, index) => {

			if (oneSku && oneSku.skuId === selectSkuResultRef.current) {
				familyTabsDescription = oneSku.productDescription && oneSku.productDescription
				if (oneSku?.prop65Message == "") {
					showRelatedResources = false;
					setProductTabspropsMessage()
				}else{
					setProductTabspropsMessage(oneSku?.prop65Message)
				}
			}
		})
		if (familyTabsDescription) {
			setProductTabsDescription(familyTabsDescription)
		}
		if (showRelatedResources == true) {
			if (document.getElementById("pdprelatedResources") && document.getElementById("pdprelatedResources").classList.contains("d-none")) {
				document.getElementById("pdprelatedResources").classList.remove("d-none")
			}
		} else {
			if (document.getElementById("pdprelatedResources")) {
				document.getElementById("pdprelatedResources").classList.add("d-none")
			}
		}

	}

	useEffect(() => {
		setTimeout(handleZoomImage, 1000)
	}, [selectSkuResultRef.current])





	function relatedResources() {

		var cbProductRelatedResources = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources
			&& (containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.contentItemList && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.contentItemList.length > 0 || containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.resourceItemsList && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.resourceItemsList.length > 0) && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources

		var familyVarientRelatedResources = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources && (containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.contentItemList
			&& containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.contentItemList.length > 0 || containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.resourceItemsList && containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.resourceItemsList.length > 0) && containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources

		var familyProductRelatedResources = containerObject.atgResponse.response.response?.familyProduct?.familyTabs?.relatedResources && (containerObject.atgResponse.response.response.familyProduct.familyTabs.relatedResources?.contentItemList?.length > 0 || containerObject.atgResponse.response.response.familyProduct.familyTabs.relatedResources?.resourceItemsList?.length > 0) && containerObject.atgResponse.response.response.familyProduct.familyTabs.relatedResources
		if (cbProductRelatedResources) {
			setRelatedResourcesObj(cbProductRelatedResources)
		}
		if (familyVarientRelatedResources) {
			setRelatedResourcesObj(familyVarientRelatedResources)
		}
		if (familyProductRelatedResources) {
			setRelatedResourcesObj(familyProductRelatedResources)
		}

	}

	async function siteSpec(inputMap) {
		var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/sitespect-details`

		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))

		setSiteSpecDetails(res.response)
		handleSiteSpecUserAction()
	}
	async function specification(event) {
		let specificationId = event.target.value
		var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/specificationDetails/${specificationId}`

		var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, null)
		setProductSpecficationDetails(res)
		handleShowMoreLength()

	}


	function handleShowMoreLength() {

		var CBSIncludedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem.length
		var CBSNotIncludedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem.length
		var CBSFeaturedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.length
		var familyProductincludedItem;
		var familyProductnotIncludedItem;
		var familyProductfeaturedItem;

		var familyVarientincludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.includedItem && productSpecficationDetailsRef.current.familyProduct.includedItem.length;
		var familyVarientnotIncludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.notIncludedItem && productSpecficationDetailsRef.current.familyProduct.notIncludedItem.length;
		var familyVarientfeaturedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.specificationList && productSpecficationDetailsRef.current.familyProduct.specificationList.length;


		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean?.skus?.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductincludedItem = oneSku.specifications && oneSku.specifications.whatsIncludedList && oneSku.specifications.whatsIncludedList.length : ""
		})
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean?.skus?.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductnotIncludedItem = oneSku.specifications && oneSku.specifications.whatsExcludedList && oneSku.specifications.whatsExcludedList.length : ""
		})

		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductfeaturedItem = oneSku.specifications && oneSku.specifications.specs && oneSku.specifications.specs.length : ""
		})

		if (CBSIncludedItem) {

			setIncludedItemLength(CBSIncludedItem);
			setShowMore({ ...showMoreRef.current, ["includedItem"]: ItemLength })
		}
		if (familyProductincludedItem) {

			setIncludedItemLength(familyProductincludedItem);
			setShowMore({ ...showMoreRef.current, ["includedItem"]: ItemLength })
		}
		if (familyVarientincludedItem) {

			setIncludedItemLength(familyVarientincludedItem);
			setShowMore({ ...showMoreRef.current, ["includedItem"]: ItemLength })
		}
		if (CBSNotIncludedItem) {

			setNotIncludedItemLength(CBSNotIncludedItem);
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: ItemLength })
		}
		if (familyProductnotIncludedItem) {

			setNotIncludedItemLength(familyProductnotIncludedItem);
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: ItemLength })
		}
		if (familyVarientnotIncludedItem) {

			setNotIncludedItemLength(familyVarientnotIncludedItem);
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: ItemLength })
		}
		if (CBSFeaturedItem) {

			setFeaturesLength(CBSFeaturedItem);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: ItemLength })
		}
		if (familyProductfeaturedItem) {

			setFeaturesLength(familyProductfeaturedItem);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: ItemLength })
		}
		if (familyVarientfeaturedItem) {

			setFeaturesLength(familyVarientfeaturedItem);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: ItemLength })
		}

	}
	function handleShowMore(key) {
		var includedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem.length
		var notIncludedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem.length

		var featuredItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.length

		var familyVarientincludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.includedItem && productSpecficationDetailsRef.current.familyProduct.includedItem.length;
		var familyVarientnotIncludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.notIncludedItem && productSpecficationDetailsRef.current.familyProduct.notIncludedItem.length;
		var familyVarientfeaturedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.specificationList && productSpecficationDetailsRef.current.familyProduct.specificationList.length;

		var familyProductIncludedItem;
		var familyProductNotIncludedItem;
		var familyProductFeaturedItem;


		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean?.skus?.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductIncludedItem = oneSku.specifications && oneSku.specifications.whatsIncludedList && oneSku.specifications.whatsIncludedList.length : ""
		})
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean?.skus?.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductNotIncludedItem = oneSku.specifications && oneSku.specifications.whatsExcludedList && oneSku.specifications.whatsExcludedList.length : ""
		})

		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean?.skus?.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductFeaturedItem = oneSku.specifications && oneSku.specifications.specs && oneSku.specifications.specs.length : ""
		})



		if (key == "includedItem") {

			setIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["includedItem"]: includedItem })
		}
		if (key == "notIncludedItem") {

			setNotIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: notIncludedItem })
		}
		if (key == "featuredItem") {

			setFeaturesLength(0);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: featuredItem })
		}
		if (key == "familyProductIncludedItem") {

			setIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["includedItem"]: familyProductIncludedItem })
		}
		if (key == "familyProductNotIncludedItem") {

			setNotIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: familyProductNotIncludedItem })
		}
		if (key == "familyProductFeaturedItem") {

			setFeaturesLength(0);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: familyProductFeaturedItem })
		}
		if (key == "familyVarientincludedItem") {

			setIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["includedItem"]: familyVarientincludedItem })
		}
		if (key == "familyVarientnotIncludedItem") {

			setNotIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: familyVarientnotIncludedItem })
		}
		if (key == "familyVarientfeaturedItem") {

			setFeaturesLength(0);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: familyVarientfeaturedItem })
		}
	}

	const handleClearErrMsg = () => {
		if (document.getElementById("errMsgAlert")) {
			document.getElementById("errMsgAlert").classList.remove("d-block")
			document.getElementById("errMsgAlert").classList.add("d-none")
		}
		if (document.getElementById("eventName")) {
			document.getElementById("eventName").classList.remove("form-error")
		}

	}

	function handleError(message) {

		if (message) {
			var error = document.getElementById('add-item-errormessage');
			error.classList.remove("d-none");
			error.classList.add("d-block");
			var cartMessage = document.getElementById('addToCartErrorMessage');
			cartMessage.innerHTML = message;
		} else {
			var error = document.getElementById('add-item-errormessage');
			error.classList.remove("d-block");
			error.classList.add("d-none");
			var cartMessage = document.getElementById('addToCartErrorMessage');
			cartMessage.innerHTML = "";
		}


	}


	function handleSelectRange(key, value) {
		setavaiable()
		setbackOrder()
		setSelectSkuResult()
		setAvalClass()
		setselectValue()
		var selectKey = [];
		var selectValue = [];
		setSelectedOneKey(key)
		setSelectedOneValue(value)
		setSelect({ ...selectRef.current, [key]: value })
		Object.entries(selectRef.current).forEach(([key, value]) => {
			selectKey.push(key)
			selectValue.push(value);
		});
		setSelectKey(selectKey)
		setselectValue(selectValue)
		handleDisplayPrice()
		defaultSelectedSku()
		handleVarientDataLayer()
	}

	function handleVarientDataLayer() {
		setTimeout(() => {

			var items = [];
			var container = containerObject?.atgResponse?.response?.response
			var priceArrCB = [];
			var categoryList = []

			if (containerObject.breadCrumbDataLayer) {
				let breadDL = containerObject.breadCrumbDataLayer;
				const categoryList1 = [breadDL["dataLayer_obj.productSubCat1"] && breadDL["dataLayer_obj.productSubCat1"], breadDL["dataLayer_obj.productSubCat2"] && breadDL["dataLayer_obj.productSubCat2"], breadDL["dataLayer_obj.productSubCat3"] && breadDL["dataLayer_obj.productSubCat3"], breadDL["dataLayer_obj.productSubCat4"] && breadDL["dataLayer_obj.productSubCat4"]];
				categoryList = categoryList1;
			}

			let queryId = `#ecommPrice_${selectSkuResultRef.current}`
			console.log("handleVarientDataLayer queryId", queryId);
			let idList = document.querySelectorAll(queryId);
			console.log("handleVarientDataLayer idList", idList);
			if (idList) {
				for (let i = 0; i < idList.length; i++) {
					console.log("handleVarientDataLayer one idList", idList[i]);
					let onePrice = idList[i].innerHTML;
					console.log("handleVarientDataLayer one onePrice", onePrice);
					if (onePrice) {
						priceArrCB.push(onePrice.replace("$", ""))
					}
				}
			}
			console.log("handleVarientDataLayer priceArrCB", priceArrCB);
			var itemBrand = "";
			if (productTypeRef?.current == "CBS Product" && containerObject?.atgResponse?.response?.response?.isproductGrouping == true) {
				itemBrand = "Carolina"
			}
			items.push({
				'item_id': container.product,
				'item_name': containerObject?.atgResponse?.response?.response?.familyVariyantDisplayName,
				'affiliation': '',
				'coupon': '',
				'currency': 'USD',
				'discount': '',
				'index': 0,
				'item_brand': itemBrand,
				'item_category': categoryList[0] ? [categoryList[0]] : categoryList[0],
				'item_category2': categoryList[1] ? [categoryList[1]] : categoryList[1],
				'item_category3': categoryList[2] ? [categoryList[2]] : categoryList[2],
				'item_category4': categoryList[3] ? [categoryList[3]] : categoryList[3],
				'item_category5': '',
				'item_list_id': '',
				'item_list_name': '',
				'item_variant': selectSkuResultRef.current ? selectSkuResultRef.current : '',
				'location_id': '',
				'price': priceArrCB,
				'quantity': 1
			})

			let ecommerce = {
				"items": items
			}
			let ecommerceData = {
				"ecommerce": ecommerce,
				"event": "select_item"
			}

			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				window.dataLayer.push(ecommerceData)
			}

		}, 2000);

	}

	function defaultSelectedSku() {
		if (selectSkuResultRef.current) {
		} else {
			setavaiable()
			setbackOrder()
			setSelectSkuResult()
			setAvalClass()
			setselectValue()
			handleUnavailableProduct()
			handleDisplayPrice()
		}
		handleFamilyTabsRelatedResources()


	}


	function selectedSku() {
		var selectKey = [];
		var selectValue = [];

		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.selectedSku && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.selectedSku.variant && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.selectedSku.variant.map((oneSelectedSKu) => {
			setSelect({ ...selectRef.current, [oneSelectedSKu.groupId]: oneSelectedSKu.value })
			selectKey.push(oneSelectedSKu.groupId)
			selectValue.push(oneSelectedSKu.value)
		})
		setSelectKey(selectKey)
		setselectValue(selectValue)

	}

	function handleUnavailableProduct() {

		var selectKey = [];
		var selectValue = [];
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {

			if (oneVarient.variantsMap[selectedOneKeyRef.current] == selectedOneValueRef.current) {
				if (selectValueRef.current) {

				}
				else {
					Object.entries(oneVarient.variantsMap).forEach(([key, value]) => {

						setSelect({ ...selectRef.current, [key]: value })
						selectKey.push(key)
						selectValue.push(value)
					});
					setSelectKey(selectKey)
					setselectValue(selectValue)
				}

			}


		})

	}

	function handleDisplayPrice() {


		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {

			handleSelectSku(oneVarient)

		})
	}


	function handleSelectSku(oneVarient) {
		var selectValue = [];
		var count = 0;
		var availVarient = [];

		// if (selectValueRef.current.length > 1) {

		Object.entries(oneVarient.variantsMap).forEach(([key, value]) => {
			selectValue.push(value);
		});
		selectValue.map((oneValue) => {
			if (selectValueRef.current.includes(oneValue)) {
				availVarient.push(oneValue)
				count++;
			}
		})
		if (count == (selectValueRef.current.length - 1)) {
			var selected = [];
			var backOrder = [];
			if (avaiableRef.current) {
				avaiableRef.current.map((oneAvailable) => {
					selected.push(oneAvailable);
				})

			}
			if(backOrderRef.current){
				backOrderRef.current.map((oneBackOrder) => {
					backOrder.push(oneBackOrder);
				})
			}

			selectValue.map((oneValue) => {
				if (avaiableRef.current && avaiableRef.current.includes(oneValue)) {
					//nothing we need to add because it already exit in the list

				} else {
					if(oneVarient?.inventoryStatus == "available"){
						selected.push(oneValue)
					}else if(oneVarient?.inventoryStatus == "backorder"){
						if(availVarient?.includes(oneValue)){
							selected.push(oneValue)
						}else{
							backOrder.push(oneValue)
						}
						
					}
					
				}
				setavaiable(selected)
				setbackOrder(backOrder)
			})


		}
		if (selectValueRef.current.length == count) {
			setSelectSkuResult(oneVarient.skuId)
			setAvalClass(oneVarient.inventoryStatus)
		}


	}


	function handleWishList(id, wishlistCount, name) {
		setProductId(id)
		setWishlistQty(wishlistCount)
		if (document.getElementById("errMsgAlert")) {
			document.getElementById("errMsgAlert").classList.remove("d-block")
			document.getElementById("errMsgAlert").classList.add("d-none")
		}
		if (document.getElementById("eventName")) {
			document.getElementById("eventName").classList.remove("form-error")
		}

		var categoryList = []
		if (containerObject.breadCrumbDataLayer) {
			let breadDL = containerObject.breadCrumbDataLayer;
			const categoryList1 = [breadDL["dataLayer_obj.productSubCat1"] && breadDL["dataLayer_obj.productSubCat1"], breadDL["dataLayer_obj.productSubCat2"] && breadDL["dataLayer_obj.productSubCat2"], breadDL["dataLayer_obj.productSubCat3"] && breadDL["dataLayer_obj.productSubCat3"], breadDL["dataLayer_obj.productSubCat4"] && breadDL["dataLayer_obj.productSubCat4"]];
			categoryList = categoryList1;
		}
		var priceArrCBFam;
		let priceArrCB = [];
		let queryId = `#ecommPrice_${id}`
		let idList = document.querySelectorAll(queryId);
		if (idList) {
			for (let i = 0; i < idList.length; i++) {
				let onePrice = idList[i].innerHTML;
				if (onePrice) {
					priceArrCB.push(onePrice.replace("$", ""))
				}

			}

		}
		let items = [];
		items.push({
			'item_id': id,
			'item_name': name,
			'affiliation': '',
			'coupon': '',
			'currency': 'USD',
			'discount': '',
			'index': 0,
			'item_brand': '',
			'item_category': categoryList[0] ? [categoryList[0]] : categoryList[0],
			'item_category2': categoryList[1] ? [categoryList[1]] : categoryList[1],
			'item_category3': categoryList[2] ? [categoryList[2]] : categoryList[2],
			'item_category4': categoryList[3] ? [categoryList[3]] : categoryList[3],
			'item_category5': '',
			'item_list_id': '',
			'item_list_name': '',
			'item_variant': '',
			'location_id': '',
			'price': priceArrCB,
			'quantity': String(wishlistCount)
		})

		let ecommerce = {
			"items": items
		}
		let ecommerceData = {
			"ecommerce": ecommerce,
			"event": "add_to_wishlist"
		}
		let ecommerceEmptyData = {
			"ecommerce": null
		}
		window.dataLayer = window.dataLayer || []
		if (window.dataLayer.length > 0) {
			window.dataLayer.push(ecommerceEmptyData)
			window.dataLayer.push(ecommerceData)
		}


	}

	function handleBazaarVoice() {

		let url = containerObject.bvUrl ? containerObject.bvUrl : "";
		if (url) {
			const head = document.querySelector("#bazaarUrl");
			const script = document.createElement("script");
			const scriptTags = head.getElementsByTagName('script');
			if (scriptTags) {
				[...scriptTags].forEach(tag => tag.remove());
			}
			script.setAttribute("src", url);
			head.appendChild(script);

			return () => {
				head.removeChild(script);
			};
		}
	}


	// useEffect(() => {

	// 	setScreenWidth(screen.width)
	// 	htmlRawContainerAccordian()
	// 	handleFamilyVarientDefaultQty()
	// 	handleFormEmpty();

	// 	window.addEventListener('scroll', function () {
	// 		// here we handle the sticky header for product
	// 		var stickyNav = document.getElementById("prod-sticky-nav");
	// 		var stickyNavSec = window.innerWidth > 767 ? document.getElementById("prod-sticky-nav") : document.getElementById("pdp-nav");
	// 		var stickyNavTop = stickyNavSec?.offsetTop;
	// 		if (!staticStickyNavSecRef.current) {
	// 			setStaticStickyNavSec(stickyNavTop)
	// 		}
	// 		var sitckyNavHeight = stickyNavSec?.offsetHeight + 1;
	// 		var body = document.getElementById('body')?.offsetTop - 10;
	// 		if (body != null && stickyNavSec) {
	// 			if (window.scrollY > stickyNavTop) {
	// 				if (window.innerWidth < 810) {
	// 					if (staticStickyNavSecRef.current < window.scrollY) {
	// 						stickyNav.classList.add('sticky-nav');
	// 						stickyNav.classList.add('d-lg-inline-flex');
	// 					} else {
	// 						stickyNav.classList.remove('sticky-nav');
	// 						stickyNav.classList.remove('d-lg-inline-flex');
	// 					}
	// 				} else {
	// 					stickyNav.classList.add('sticky-nav');
	// 					stickyNav.classList.add('d-lg-inline-flex');
	// 				}
	// 			} else {
	// 				stickyNav.classList.remove('sticky-nav');
	// 				stickyNav.classList.remove('d-lg-inline-flex');
	// 			}
	// 		}
	// 	});

	// }, [loaderStatus])

	function scrollToView(id) {
		console.log("scrollToView called...",id);
		var mapConfiguration = {
			"description": "pdp-desc-body",
			"specification": "pdp-spec-body",
			"reviews": "pdp-reviews-body",
			"qAndA": "pdp-qAndA-body"

		}
		var viewId = mapConfiguration[id];
		var scrollId = document.getElementById(viewId);
		var clickId = document.getElementById(id);

		if (clickId) {
			if (clickId.classList.contains("d-none")) {
				clickId.classList.remove("d-none");
				clickId.classList.add("d-block");
			}
		}
		if (screenWidthRef.current < 1024) {
			if (scrollId) {
				//scrollId.classList.add("show")
				if (!scrollId.classList.contains("show")) {
					let scrollViewId = id + "_accordion_button";
					document.getElementById(scrollViewId).click();
				}
			}
		}


		setTimeout(() => {
			let stickyNav;
			if (window.innerWidth > 767) {
				stickyNav = document.getElementById("prod-sticky-nav");
			} else {
				stickyNav = document.getElementById("pdp-nav");
			}
			var stickyNavSec = stickyNav.offsetTop;
			if (stickyNavSec > 0) {
				window.scrollTo({
					top: parseInt(stickyNavSec),
					behavior: 'smooth'
				})
			}
			var scrollPos = document.getElementById(id).offsetTop - stickyNav.offsetHeight;
			const stickynav = stickyNav.offsetHeight;
			if (stickyNavSec > 0) {
				scrollPos = scrollPos - stickynav;
			}
			scrollTop(scrollPos)
		}, 500);



	}

	const scrollTop = (length) => {
		window.scrollTo({
			top: parseInt(length),
			behavior: 'smooth'
		})
	};



	function Decrement() {
		if (count > 1) {
			let qty = count - 1;
			setCount(qty);
		}

	}
	function Increment() {
		if (count < 999) {
			let qty = count + 1;
			setCount(qty);
		}
	}

	function handleDecrement(productId) {

		if (productId != " ") {
			var count = parseInt(document.getElementById(productId).getAttribute("value"))
			if (count > 1) {
				count = count - 1;
				setproductCount({ ...productcountref.current, [productId]: count })
			}
		}


	}
	function handleIncrement(productId) {
		if (productId != " ") {
			var count = parseInt(document.getElementById(productId).getAttribute("value"))
			if (count < 999) {
				count = count + 1;
				setproductCount({ ...productcountref.current, [productId]: count })
			}
		}

	}






	async function handleAddToCart(event, urlProductId) {

		console.log("handleQuickAddToCart fired in pdp");
		event.preventDefault();
		var message = "";
		handleError(message);
		var actionUrl = "api/rest/cb/cart/pdp/add-to-cart";
		var formData = "";
		var productId ="";
		var quantity = "";
		try{
			 formData = new FormData(event.target);
			 productId = formData.get("productId")
			 quantity = formData.get("quantity")
		}catch{
			if(urlProductId.includes("FAM_")){
				productId = urlProductId.replace("FAM_","");
				console.log('productId????',productId);
			}else{
				productId = urlProductId;
			}
			quantity = '1';
		}
		// productId = formData?.get("productId")? formData.get("productId") : productId;
		// quantity = formData?.get("quantity") ? formData.get("quantity") : 1 ;
		var searchParam = window.location.search
		var orgid = "";
		var cid = "0";
		if (searchParam) {

			let params = new URLSearchParams(searchParam);
			if (params.get("orgid") != null) {
				orgid = params.get("orgid");
			}
			if (params.get("cid") != null) {
				cid = params.get("cid");
			}

		}

		const cartDetailMap = {
			addItemCount: "1",
			productId: productId,
			catalogRefId: productId,
			quantity: quantity,
			allowDLAddToCart: "true",
			organizationId: orgid,
			courseId: cid
		}
		var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(cartDetailMap))
		if (res.result == "success") {
			var response = JSON.parse(res.response).response;
			setActionToggle(!actionToggleRef.current)
			setProductName(response.response.validproducts[0].productName)
			let count = parseInt(response.response.validproducts[0].Quantity)
			setCount(count)
			setProductId(response.response.validproducts[0].ProductId)
			dispatch(updateProfileDetailsAction(true, "cart"));
			setTriggerModal(true)
			document.getElementById("pdpAddToCartSuccessModal").click()
			handleSiteSpecDataLayer(response)
			handleEcommerceAddToCartDatalayer(response)
		}
		else {
			handleError(res.errorMessage)
		}
	}

	function handleEcommerceAddToCartDatalayer(response) {
		var categoryList = []

		if (containerObject.breadCrumbDataLayer) {
			let breadDL = containerObject.breadCrumbDataLayer;
			const categoryList1 = [breadDL["dataLayer_obj.productSubCat1"] && breadDL["dataLayer_obj.productSubCat1"], breadDL["dataLayer_obj.productSubCat2"] && breadDL["dataLayer_obj.productSubCat2"], breadDL["dataLayer_obj.productSubCat3"] && breadDL["dataLayer_obj.productSubCat3"], breadDL["dataLayer_obj.productSubCat4"] && breadDL["dataLayer_obj.productSubCat4"]];
			categoryList = categoryList1;
		}

		let items = [];
		items.push({
			'item_id': productIdRef.current,
			'item_name': productNameRef.current,
			'affiliation': '',
			'coupon': '',
			'currency': 'USD',
			'discount': '',
			'index': 0,
			'item_brand': '',
			'item_category': categoryList[0] ? [categoryList[0]] : categoryList[0],
			'item_category2': categoryList[1] ? [categoryList[1]] : categoryList[1],
			'item_category3': categoryList[2] ? [categoryList[2]] : categoryList[2],
			'item_category4': categoryList[3] ? [categoryList[3]] : categoryList[3],
			'item_category5': '',
			'item_list_id': '',
			'item_list_name': '',
			'item_variant': '',
			'location_id': '',
			'price': "N/A",
			'quantity': String(count)
		})

		let ecommerce = {
			"items": items
		}
		let ecommerceData = {
			"ecommerce": ecommerce,
			"event": "add_to_cart"
		}
		let ecommerceEmptyData = {
			"ecommerce": null
		}
		window.dataLayer = window.dataLayer || []
		if (window.dataLayer.length > 0) {
			window.dataLayer.push(ecommerceData)
		}
	}

	function handleSiteSpecDataLayer(response) {
		let categoryList = [];
		let productList = []
		let category = JSON.parse(response?.dataLayer_obj)
		const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

		categoryList = categoryList1;
		const productMapDuplicate = {
			"productId": response.response.validproducts[0].ProductId,
			"category": categoryList1
		}
		let productMap = productMapDuplicate;
		productList.push(productMap)
		const page = {
			"type": "product",
			"products": productList
		}
		const PDP_payload = {
			"type": "add-to-cart", 
			"page": page
		}
		window.ssRecsInfo = window.ssRecsInfo || {}
		window.ssRecsInfo = PDP_payload
		console.log("sitespect-user-action in addtocart one");
		window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': PDP_payload }))
		console.log("sitespect-user-action in addtocart two");
	}


	function handleQuickView(quickViewDetails) {
		setProductDetailsObj()
		setProductDetailsObj(quickViewDetails)

	}

	function handleQuickViewCount(prodCount) {
		if (prodCount != 0) {
			setSolrValue(prodCount)
		} else {
			setSolrValue("")
		}
	}

	function cartProductDetailsCallBack(quickViewDetails) {

	}

	function handleZoomImage() {
		if (document?.querySelector('#pdp-gallery')) {
			document.querySelector('#pdp-gallery').addEventListener("slide.bs.carousel", function (event) {
				handleVideoPause(event);

			})
		}
		let zoomTag = document?.querySelectorAll(".zoom")
		for (let i = 0; i < zoomTag?.length; i++) {
			zoomTag[i].addEventListener("mousemove", function (event) {
				zoomIn(event);

			});
			zoomTag[i].addEventListener("mouseleave", function (event) {
				zoomOut(event);

			});
		}
		return true;

	}
	function zoomIn(e) {
		e.preventDefault();
		let offsetX;
		let offsetY;
		let img = e.target.src;
		let imgId = e.target.id;
		var zoomer = document.getElementById(`zoomImage_${imgId}`);
		img = zoomer.getAttribute("imageurl");
		zoomer.style.backgroundImage = `url(${img})`;
		e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
		e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
		let x = offsetX / zoomer.offsetWidth * 100
		let y = offsetY / zoomer.offsetHeight * 100
		zoomer.style.backgroundPosition = x + '% ' + y + '%';


	}



	function zoomOut(e) {
		let imgId = e.target.id;
		var zoomer = document.getElementById(imgId);

		zoomer.style.backgroundImage = ""
		zoomer.style.backgroundPosition = ""
		zoomer.style.removeProperty("backgroundImage");
		zoomer.style.removeProperty("backgroundPosition");
	}

	function addToCartSuccessFromWhatsInclude(res){
		if (res.result == "success") {
			var response = JSON.parse(res.response).response;
			setActionToggle(!actionToggleRef.current)
			setProductName(response.response.validproducts[0].productName)
			let count = parseInt(response.response.validproducts[0].Quantity)
			setCount(count)
			setProductId(response.response.validproducts[0].ProductId)
			dispatch(updateProfileDetailsAction(true, "cart"));
			setTriggerModal(true)
			document.getElementById("pdpAddToCartSuccessModal").click()
			handleSiteSpecDataLayer(response)
			handleEcommerceAddToCartDatalayer(response)
		}
		else {
			handleError(res.errorMessage)
		}

	}


	function handleReviewHideorShow() {
		document.addEventListener('scroll', () => {
			if (document.getElementById('reviews') && document.getElementById('reviews').classList.contains("d-none")) {
				document.getElementById('reviews').classList.remove("d-none");
				document.getElementById('reviews').classList.add("d-block");
			}

		});
		document.addEventListener("DOMContentLoaded", (event) => {
			const viewportHeight = window.innerHeight;
			const contentHeight = document.documentElement.offsetHeight;
			if (contentHeight < viewportHeight) {
				if (document.getElementById('reviews') && document.getElementById('reviews').classList.contains("d-none")) {
					document.getElementById('reviews').classList.remove("d-none");
					document.getElementById('reviews').classList.add("d-block");
				}
			}
			window.addEventListener('resize', function (event) {
				if (document.getElementById('reviews') && document.getElementById('reviews').classList.contains("d-none")) {
					document.getElementById('reviews').classList.remove("d-none");
					document.getElementById('reviews').classList.add("d-block");
				}
			});

		});
	}

	function handleReviewScroll() {
		if (document?.querySelector('div[data-bv-show="rating_summary"]')) {
			document?.querySelector('div[data-bv-show="rating_summary"]').addEventListener('click', function (event) {

				setTimeout(() => {
					scrollToView('reviews');
					if (window.innerWidth > 767) {
						handleScrollClick()
					}
				}, 500);

			})
		}
	}
	function handleScrollClick() {
		document.getElementById(`scrollReviewId`).click();

	}

	function handlePdfDataLayer() {
		if (containerObject?.atgResponse?.response?.response?.teacherResource?.detailPDF) {
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				window.dataLayer.push({
					'pageType': 'content resource'
				});
			}
		}

	}
	function handleHtmlAndVideoDataLayer() {
		if (containerObject?.atgResponse?.response?.response?.teacherResource?.detailVideo || containerObject?.atgResponse?.response?.response?.teacherResource?.detailText) {
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				window.dataLayer.push({
					'pageName': 'Teacher Resource Detail',
					'channel': 'Content Detail',
					'pageType': 'content resource'
				});
			}

		}
	}
	function handlePdpDataLayer() {
		if (productTypeRef.current && productTypeRef.current == "CBS Product" && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isproductGrouping == false) {
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				dataLayer.push({
					'pageName': 'Product Detail - Individual',
					'channel': 'Product Detail',
					'event': 'productDetailChild'
				});
			}
		}

		if (productTypeRef.current && productTypeRef.current == "CBS Product" && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isproductGrouping == true) {
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				dataLayer.push({
					'pageName': 'Product Detail - Variants',
					'channel': 'Product Detail'
				});
			}
		}
		if (productTypeRef.current && productTypeRef.current == "CBS Family") {
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				dataLayer.push({
					'pageName': 'Product Detail - Family',
					'channel': 'Product Detail'
				});
			}
		}

	}

	function getLastPathname(prdUrl){
		prdUrl && console.log("prdUrl...",prdUrl);
		let pathName = ''
		console.log('includeQuickRefId....',includeQuickRefId?.current);
		if(isValidUrl(prdUrl)){
			 pathName = new URL(prdUrl).pathname
			pathName && console.log("pathName...",pathName);
			const pathArr = pathName?.split('/').filter(Boolean)
			if(pathArr[pathArr.length - 1].includes(".")){
				const prdId = pathArr[pathArr.length - 1].split('.')[0]
				// if(prdId.includes('FAM_')){	
				// 	return prdId.replace('FAM_',"")
				// }
				
				return pathArr[pathArr.length - 1].split('.')[0]
			}
			
			return pathArr[pathArr.length - 1]
		}else{
			 pathName = prdUrl
			 pathName && console.log("pathName...",pathName);
			 const pathArr = pathName.split('/').filter(Boolean)
			 if(pathArr[pathArr.length - 1].includes(".")){
				const prdId = pathArr[pathArr.length - 1].split('.')[0];
				// if(prdId.includes('FAM_')){
				// 	return prdId.replace('FAM_','');
				// }
				return pathArr[pathArr.length - 1].split('.')[0];
			 }
			 return pathArr[pathArr.length - 1]
		}
	}

	function isProduct(linkUrl){
		if(linkUrl){
			let pathName = linkUrl
			pathName && console.log("pathName.111..",pathName);
			const pathArr = pathName && pathName.split('/').filter(Boolean)
			if(pathArr && pathArr[pathArr.length - 1]?.includes(".")){
				const splittedPrdId = pathArr[pathArr.length - 1]?.split('.')[1].split('?')[0]
				
				if(splittedPrdId == 'pr'){
					return true;
				}
			}
		}
		return false;
	}

	function isValidUrl(string) {
		try {
		  new URL(string);
		  return true;
		} catch (err) {
		  return false;
		}
	  }

	  function isRetailPrice(retialPrice, basePrice) {
		//console.log('retialPrice---- ', retialPrice)
		//console.log('basePrice---- ', basePrice)
		if (retialPrice != null && retialPrice != "$0.00" && basePrice != null && basePrice != "$0.00") {
			if (retialPrice.includes("$")) {
				retialPrice = retialPrice.replace("$", "");
			}
			if (retialPrice.includes(",")) {
				retialPrice = retialPrice.replace(",", "");
			}

			if (basePrice.includes("$")) {
				basePrice = basePrice.replace("$", "");
			}
			if (basePrice.includes(",")) {
				basePrice = basePrice.replace(",", "");
			}
			console.log('democonsole')
			if (parseFloat(retialPrice) > parseFloat(basePrice)) {
				console.log('return true')
				return "true"
			} else {
				console.log('return false')
				return "false"
			}
		} else {
			console.log('return false')
			return "false"
		}


	}

	function handleCloseQuickView(){
		document.addEventListener('click', function(event) {
			var pdpQuickClass = event.target.className;
			if(pdpQuickClass.includes("pdpIncludedQuickView")){
				event.preventDefault();
			}else{
				handleRemoveQuickView()
			}
		})
	}

	function handleIncludeQuickView(prdUrl,index, type){
		console.log("hoverIndex...",index, type);
		handleRemoveQuickView()
		var productId =getLastPathname(prdUrl);
		let alterProductId = productId;
		if(productId.includes('.pr')){
			alterProductId = productId.replace('.pr','');
		}
		 setIncludeQuickRefId(productId.concat("_").concat(index))
        console.log("handleIncludeQuickView productId",productId);
		setHoverProductId(alterProductId);
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${alterProductId}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res !== null) {
                    var productDetatils = (JSON.parse(res.response)).response
                   console.log("handleIncludeQuickView productDetatils",productDetatils);
				   console.log("handleIncludeQuickView productIdquickRef",includeQuickRefId.current);
				//   setWhatsIncludedList(...whatsIncludedListRef.current,{index, })
				setIncludeQuickRef(productDetatils)
				  if(type === "include"){
					console.log("inside include....",type);
					  setWhatsIncludedList((prevState) => {
					   return {
						   ...prevState,
						   [index]: productDetatils
					   };
				   });
				  }else{
					console.log("inside notInclude....",type);
					setWhatsNotIncludedList((prevState) => {
						return {
							...prevState,
							[index]: productDetatils
						};
					});
				  }
                } else {
                   
                }
            })
			setIncludeQuickRefId(productId.concat("_").concat(index)) 
			console.log("after1.. includeQuickRef...", includeQuickRef.current);
		console.log("after1.. whatsNotIncludedList....",whatsNotIncludedListRef.current);
		console.log("after1.. whatsIncludedList....",whatsIncludedListRef.current);
	}

	function handleWhatsIncludeHover(prdUrl,index, type){
		console.log("Value of the whats included for the index" , index ,"is",whatsIncludedListRef.current[index]);
		console.log('handleWhatsIncludeHover called...');
		console.log("whatsIncludedList...before..",whatsIncludedListRef.current);
		console.log('index in handleWhatsIncludeHover...',index);
		const productId = getLastPathname(prdUrl);
		if(productId.includes('.pr')){
			const alterProductId = productId.replace('.pr','');
			setHoverProductId(alterProductId);
		}else{
			setHoverProductId(productId);
		}
		if(type == "include"){
			if(whatsIncludedListRef.current && whatsIncludedListRef.current[index]){
				console.log("inside if???????????",index);
				setIncludeQuickRefId(productId.concat("_").concat(index))
				whatsIncludedListRef.current && setIncludeQuickRef(whatsIncludedListRef.current[index])
			}else{
				console.log('inside else???????????',index);
				setIncludeQuickRefId(productId.concat("_").concat(index))
				handleIncludeQuickView(prdUrl,index, "include")
			}
		}else{
			if(whatsNotIncludedListRef.current && whatsNotIncludedListRef.current[index]){
				console.log("inside if???????????",index);
				setIncludeQuickRefId(productId.concat("_").concat(index))
				whatsNotIncludedListRef.current && setIncludeQuickRef(whatsNotIncludedListRef.current[index])
			}else{
				console.log('inside else???????????',index);
				setIncludeQuickRefId(productId.concat("_").concat(index))
				handleIncludeQuickView(prdUrl,index, "notInclude")
			}
		}
		console.log("after includeQuickRef...", includeQuickRef.current);
		console.log("after whatsNotIncludedList....",whatsNotIncludedListRef.current);
		console.log("after whatsIncludedList....",whatsIncludedListRef.current);
	}

	function handleRemoveQuickView(){
		setIncludeQuickRefId()
		setIncludeQuickRef()
	}

	return (<>

		{containerObject.atgResponse.result == "success" &&  loaderStatus != true ? <>
			{console.log("pdp productdetails CWV")}
			{productDetailsObjRef.current ? <ProductQuickViewModal productObj={productDetailsObjRef.current} solrValue={solrValueRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack}/> : ""}
			{/* {<div className="script" dangerouslySetInnerHTML={{ __html: jsonIdRef.current }}></div>} */}
			<p id="warning65" data-bs-toggle="modal" data-bs-target="#prop65" data-bs-dismiss="modal" title="" className="fwb icon-content m-0"></p>
			<ProductModal domainName={domainNameRef.current} productImage={productImageRef.current} />
			<P65Warning message={warningRef.current} isCart={false} />
			<CbLoginModal triggerAddToList={true}  isPDP={true}/>
			<p className="m-0" data-bs-toggle="modal" data-bs-target="#newListModalww" onClick={handleClearErrMsg} data-bs-dismiss="modal" id="afterLoginAddToListFromPDP"></p>
			<AddShoppingListModal pageFrom="pdp" productId={productIdRef.current ? productIdRef.current : ""} quantity={wishlistQtyRef.current ? wishlistQtyRef.current : ""} />
			<AddShoppingListModalTwo pageFrom="quick" quantity={1} productId={hoverProductIdRef.current ? hoverProductIdRef.current : ''} />
			{triggerModalRef.current == true ? <AddToCartSuccessModal productId={productIdRef.current} quantity={count} productName={productNameRef.current} actionToggle={actionToggleRef.current}/> : ""}
			<p className="m-0" id="pdpAddToCartSuccessModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#addToCartSuccess"></p>
			<p className="m-0" id="productImageModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#productImage"></p>

			<div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0  header-mobile-padding header-mobile-padding-css`} >
				<div className="pdpcss row px-0">
					<div className="col-12 col-md-12 py-1">
						<BreadCrumbsContainer displayPrintBtn="true" breadCrumbs={containerObject && containerObject.breadCrumb ? containerObject.breadCrumb : ""} ></BreadCrumbsContainer>
					</div>
					{/* <div className="col-1 d-md-block d-none">
						{containerObject.atgResponse.response.response ?
							<>
								<div className="col-12 col-md-1 d-none d-lg-block">
									<button className="btn btn-light c-print-btn text-end" type="button" onClick={() => window.print()} >
										<i className="bi bi-printer-fill" aria-hidden="true"></i>Print
									</button>
								</div>
							</>
							: ""}
					</div> */}
				</div>
				<div className="col-12 pdpErrorMessage">
					<div className="alert alert-danger" role="alert" id="add-item-errormessage">
						<p id="addToCartErrorMessage"></p>
					</div>
				</div>
				{/* teacherResource product html started here */}
				{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailText ?
					<>

						<div className="rdp trpadding"><div className="rdp-content rdp teacher-resource " id="content">
							<h1 dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : "" }} ></h1>
							<div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailText && containerObject.atgResponse.response.response.teacherResource.detailText.htmlBlock ? containerObject.atgResponse.response.response.teacherResource.detailText.htmlBlock : "" }}></div>

						</div></div>
						<div className="">
							<TeacherResourcesCarousel domainName={domainNameRef.current} carouselData={containerObject.atgResponse.response.response.teacherResource?.detailText?.productsCarousel?.productDisplayGridList ? containerObject.atgResponse.response.response.teacherResource?.detailText?.productsCarousel?.productDisplayGridList : ""} quickviewCallback={handleQuickView} solrValue={handleQuickViewCount} />
						</div>
					</>

					: ""}
				{/* teacherResource product html ended here */}

				{/* teacherResource product started pdf here */}

				{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailPDF ?



					<>
						<div className="rdp-pdp-header">
							<div className="row text-center">
								<div className="col">
									<h1 className="content-pdf-h1" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : "" }}></h1>
								</div>
								<div className="col-12 col-md-auto"><a className="rdp-download btn btn-primary" target="_blank" href={pdfUrl ? pdfUrl : ""}>Download PDF</a></div>
								<div className="col-12">

									<p className="m-0">{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailPDF && containerObject.atgResponse.response.response.teacherResource.detailPDF.shortDescription ? containerObject.atgResponse.response.response.teacherResource.detailPDF.shortDescription : ""}</p>
									<p className="fwb m-0">If the PDF does not display below, you may also <a title="download here" href={pdfUrl ? pdfUrl : ""}>download it here</a>.</p>
								</div>
							</div>
						</div>



						{pdfUrl ?
							<div className="rdp-pdp-embed c-container">
								<iframe frameborder="0"
									marginheight="0"
									marginwidth="0"
									width="100%"
									height="800px"
									scrolling="auto"
									id="mtr-iframe"
									className="mtr-preview-iframe"
									src={pdfUrl ? pdfUrl : "empty"}>
								</iframe>
							</div> : ""}
						<TeacherResourcesCarousel domainName={domainNameRef.current} carouselData={containerObject.atgResponse.response.response.teacherResource?.detailPDF?.productsCarousel?.productDisplayGridList ? containerObject.atgResponse.response.response.teacherResource?.detailPDF?.productsCarousel?.productDisplayGridList : ""} quickviewCallback={handleQuickView} solrValue={handleQuickViewCount} />

					</>

					: ""}

				{/* teacherResource product started pdf here */}

				{/* video product started  here */}
				{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailVideo ?
					<div className="rdp-content trpadding" id="content">

						<div className="rdp-pdp-header">
							<div className="row text-center">
								<div className="col-12 mb-0">
									<h1 className="content-video-h1">{containerObject.atgResponse.response.response.teacherResource.detailVideo.displayName ? containerObject.atgResponse.response.response.teacherResource.detailVideo.displayName : ""}</h1>
								</div>
								<div className="col-12 mb-0">
									<p className="m-0"></p>
								</div>
							</div>
						</div>
						<div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.teacherResource.detailVideo.htmlBlock ? containerObject.atgResponse.response.response.teacherResource.detailVideo.htmlBlock : "" }}></div>
						<TeacherResourcesCarousel domainName={domainNameRef.current} carouselData={containerObject.atgResponse.response.response.teacherResource?.detailVideo?.productsCarousel?.productDisplayGridList ? containerObject.atgResponse.response.response.teacherResource?.detailVideo?.productsCarousel?.productDisplayGridList : ""} quickviewCallback={handleQuickView} solrValue={handleQuickViewCount} />
					</div>
					: ""}
				{/* video product ended here */}

				{/* CBS product started here */}

				{containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.prodType == "CBS Product" && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isproductGrouping == false ?
					<>

						{/* <div dangerouslySetInnerHTML={{
							__html: `<script type="application/ld+json">
							${containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.schemaJson && containerObject.atgResponse.response.response.schemaJson.schemaJson}
						</script>`}}>
						</div> */}
						<div id="body" className={`row ${screenWidthRef.current < 810 ? "p-0 m-0 g-0" : ""}`}>
							<div className="col-12 order-2 order-md-1 " style={{ "min-height": "118px"}}>

								<div className="row " id="prod-sticky-nav">
									<div className="col prod-nav-title">
										<h1 dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : "" }} />

									</div>
									<div className="col-12 pdp-nav" id="pdp-nav">

										<ul className="row prod-nav-group list-unstyled g-0">
											<li className="col-6 prod-nav-item hide-on-sticky">

												<div className="m0"><span className="fwb ftms">Item #:</span> <span id="pdp-skuId">{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : ""}</span></div>
											</li>
											<li className="col-6 prod-nav-item hide-on-sticky">
												{prodIdRef.current ? isDlproductRef.current == false ?
													<div data-bv-show="rating_summary" data-bv-product-id={prodIdRef.current} ></div> : "" : ""}
											</li>
											<li className="col prod-nav-item bg-light-grey">
												<p className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("description")}>
													Description
												</p>
											</li>

											<li className="col prod-nav-item bg-light-grey">
												<p className="pdp-scroll-to hyperLinkStyle"
													onClick={() => scrollToView("specification")}
												>
													Specifications
												</p>
											</li>
											{isDlproductRef.current == false ? <>
												<li className="col prod-nav-item bg-light-grey">
													<p id="scrollReviewId" className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("reviews")}>

														Reviews
													</p>
												</li>
												{productTypeRef.current != "CBS Family" ?
													<li className="col prod-nav-item bg-light-grey">
														<p className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("qAndA")}>

															Q&amp;A
														</p>
													</li> : ""}</> : ""}
										</ul>
										{productTypeRef.current ?handleReviewScroll():""}
									</div>
								</div>
							</div>
							<div className="col-12 col-md-6 order-1 order-md-2 py-4">
								<div id="pdp-gallery" className="carousel carousel-dark slide" data-bs-ride="false" data-bs-interval="false">
									<div className="carousel-inner pdp-gallery-slides">
										{containerObject?.atgResponse?.response?.response?.isDLProduct == false ?
											<div className="carousel-item active modalImage_1" id="modal-image1" onClick={() => handleProductImage(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.largeImg)} >
												{screenWidthRef.current > 810 ?
													<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage new-1" src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)} />
													: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage new-2" src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)} />}
												<div id="zoomImage_1" className="zoom cbProductZoom printHideImage " imageurl={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.largeImg)} >
													{screenWidthRef.current > 810 ?
														<img className="test-3 new-3" width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} id="1" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} fetchpriority="high" 
														src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)} 
														srcSet={`${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.smallImg)} 480w, 
																${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.mediumImg)} 1024w, 
																${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.largeImg)} 1200w`}
																sizes="(min-width: 480px) 100vw,
																(min-width: 1024px) 100vw,
																(min-width: 1200px) 100vw,
																100vw"	
																onError={handleReplaceLargeImage} />
														: <img className="test-4 new-4" width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} id="1" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""}
														 src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)} 
														 srcSet={`${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.smallImg)} 480w, 
																${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.mediumImg)} 1024w, 
																${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.largeImg)} 1200w`}
																sizes="(min-width: 480px) 100vw,
																(min-width: 1024px) 100vw,
																(min-width: 1200px) 100vw,
																100vw"	
														 onError={handleReplaceLargeImage} />}
												</div>
												{/* <Zoom
														img={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)}
														zoomScale={2}
														width={screenWidthRef.current > 810 ? 400 : 300}
														height={screenWidthRef.current > 810 ? 400 : 300}
														className="imagepointer replaceImage_1 printHideImage"
													/> */}

												{/* {handleZoomImage() == true ? "" : ""} */}
											</div>
											:
											<div>
												{screenWidthRef.current > 810 ?
														<img width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} className="type-1 new-5" decoding="async"  id="1" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} fetchpriority="high" 
														srcSet={`${domainNameRef.current.concat(containerObject.atgResponse.response.response.standardResult.galleryPageResult.smallImg)} 480w, 
														${domainNameRef.current.concat(containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)} 1024w, 
														${domainNameRef.current.concat(containerObject.atgResponse.response.response.standardResult.galleryPageResult.largeImg)} 1200w`}
														src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)} 
														sizes="(min-width: 480px) 100vw,
														(min-width: 1024px) 100vw,
														(min-width: 1200px) 100vw,
														100vw"															onError={handleReplaceLargeImage} />
														: <img width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} className="type-2 new-6" decoding="async" id="1" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} 
														src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.mediumImg)} 
														srcSet={`${domainNameRef.current.concat(containerObject.atgResponse.response.response.standardResult.galleryPageResult.smallImg)} 480w, 
														${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.mediumImg)} 1024w,
														 ${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.standardResult?.galleryPageResult?.largeImg)} 1200w`}
														 sizes="(min-width: 480px) 100vw,
														 (min-width: 1024px) 100vw,
														 (min-width: 1200px) 100vw,
														 100vw"	
														 onError={handleReplaceLargeImage}/>}
											</div>}



										{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult.galleryPageResult.addlTopImagesList.map((addlImg, index) => {
											return (<>
												<div id={`modal-image${index + 2}`} className={`carousel-item modalImage_${index + 2}`} onClick={() => handleProductImage(addlImg.addlTopLargeImg)} >
													{screenWidthRef.current > 810 ?
														<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage new-7" src={domainNameRef.current.concat(addlImg.addlTopMediumImg)} />
														: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage new-8" src={domainNameRef.current.concat(addlImg.addlTopMediumImg)} />}
													{/*<Zoom

															img={domainNameRef.current.concat(addlImg.addlTopMediumImg)}
															zoomScale={3}
															width={screenWidthRef.current > 810 ? 400 : 300}
															height={screenWidthRef.current > 810 ? 400 : 300}
															className={`imagepointer replaceImage_${index + 2} printHideImage`}
														/> */}
													<div id={`zoomImage_${index + 2}`} className="zoom cbProductZoom printHideImage " imageurl={domainNameRef.current.concat(addlImg.addlTopLargeImg)}>
														{screenWidthRef.current > 810 ?
															<img fetchpriority="high" width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} id={index + 2} decoding="async"  alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} src={domainNameRef.current.concat(addlImg.addlTopMediumImg)} onError={handleReplaceLargeImage}  />
															:
															<img width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} id={index + 2} decoding="async" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} src={domainNameRef.current.concat(addlImg.addlTopMediumImg)} onError={handleReplaceLargeImage} />}
													</div>




													{/* {handleZoomImage() == true ? "" : ""} */}
												</div>
											</>)
										})}
										{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult.galleryPageResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.featureVideosList && containerObject.atgResponse.response.response.standardResult.galleryPageResult.featureVideosList && containerObject.atgResponse.response.response.standardResult.galleryPageResult.featureVideosList.map((oneVideo, index) => {
											return (<>
												<div className="carousel-item">
													<Link>
														<ReactPlayerLoader
															id="playlist-player-id"
															playerId="xlAiVNpci"
															accountId="17907428001"
															videoId={oneVideo.videoURL}
															onFailure={onFailure}
															onSuccess={onSuccess}
															options={{ responsive: true, autoplay: false, muted: false }}
														/>

													</Link>
												</div>
											</>)
										})}
									</div>
									{handleShowThumbNailProduct(containerObject.atgResponse.response.response.standardResult.galleryPageResult.addlImagesList.length, containerObject.atgResponse.response.response.standardResult.galleryPageResult.featureVideosList.length) >= 1 ? <>
										<button className="carousel-control-prev " type="button" data-bs-target="#pdp-gallery" data-bs-slide="prev">
											<span className="carousel-control-prev-icon" aria-hidden="true"></span>
											<span className="visually-hidden">Previous</span>
										</button>
										<button className="carousel-control-next " type="button" data-bs-target="#pdp-gallery" data-bs-slide="next">
											<span className="carousel-control-next-icon" aria-hidden="true"></span>
											<span className="visually-hidden">Next</span>
										</button></> : ""}
									<div className="carousel-indicators pdp-gallery-thumbnails">
										{handleShowThumbNailProduct(containerObject.atgResponse.response.response.standardResult.galleryPageResult.addlImagesList.length, containerObject.atgResponse.response.response.standardResult.galleryPageResult.featureVideosList.length) >= 1 ?
											<>
												<button type="button" data-bs-target="#pdp-gallery" data-bs-slide-to="0" className="active" aria-label="Slide 0" aria-current="true">
													{screenWidthRef.current > 810 ?
														<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.thumbnailImg)} />
														: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.thumbnailImg)} />}
												</button>
												{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.addlImagesList.map((addlImg, index) => {
													return (<>
														<button type="button" data-bs-target="#pdp-gallery" data-bs-slide-to={index + 1} c aria-label={`Slide ${index}`} aria-current="true">
															{screenWidthRef.current > 810 ?
																<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(addlImg.addlThumbnailImg)} />
																:
																<img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(addlImg.addlThumbnailImg)} />}
														</button>
													</>)
												})}

												{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryPageResult.featureVideosList && containerObject.atgResponse.response.response.standardResult.galleryPageResult.featureVideosList.map((videoImg, index) => {
													return (
														<button className="video-thumb" type="button" data-bs-target="#pdp-gallery" data-bs-slide-to={containerObject.atgResponse.response.response.standardResult.galleryPageResult.addlImagesList.length + index + 1} aria-label={`Slide ${containerObject.atgResponse.response.response.standardResult.galleryPageResult.addlImagesList.length + index + 1}`}>
															{screenWidthRef.current > 810 ?
																<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(videoImg.videoThumbnailPath)} />
																: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(videoImg.videoThumbnailPath)} />}
															<div className="video-thumb-overlay">
																<i className="bi bi-play-circle"></i>
																<span>Video</span>
															</div>
														</button>)
												})}
											</> : ""}</div>
								</div>
							</div>

							{containerObject.atgResponse.response.response.isDiscontinuedItem == true && containerObject.atgResponse.response.response.replacementProduct ?
							<>
							    <div class="col-12 col-md-6 order-3 mt-4 replacementTile restricted-item-row pdp-desc">
                                    <div style={{"line-height": "1.35rem"}}>
                                        <span class="replacementNoticeTitle">This item is discontinued. Please view this replacement item: </span>
                                    </div>
                                    <div id="title">
                                        <h5 dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.replacementProduct.displayName ? containerObject.atgResponse.response.response.replacementProduct.displayName : "" }} />
                                        <div>
                                            <span className="fwb ftms">Item #:</span>
                                            <span id="pdp-skuId">{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.replacementProduct.productId ? containerObject.atgResponse.response.response.replacementProduct.productId : ""}</span>
                                        </div>
                                    </div>

                                    {containerObject.atgResponse.response.response
                                        && containerObject.atgResponse.response.response.standardResult
                                        && containerObject.atgResponse.response.response.standardResult.pdpOrderResult
                                        && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.hidePrice
                                        && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.hidePrice == "true" ?
                                        <div className="col-12 cbProduct pdp-desc-price-hidePrice fw-bold">
                                            Call For Pricing
                                        </div>
                                        :
                                        <>
                                            {containerObject.atgResponse.response.response
                                                && containerObject.atgResponse.response.response.replacementProduct
                                                && containerObject.atgResponse.response.response.replacementProduct.pdpPrice
                                                && containerObject.atgResponse.response.response.replacementProduct.pdpPrice.basePrice ?
                                                <div className="col-12 pdp-desc-price">
                                                    {profileDetails && profileDetails.userType && profileDetails.userType === 2 && containerObject.atgResponse.response.response.replacementProduct.pdpPrice.retailPrice ?
                                                        <>
                                                            {handleRetailPrice(containerObject.atgResponse.response.response.replacementProduct.pdpPrice, profileDetails.userType) == "equal" ?
                                                                <div id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.replacementProduct?.productId}`} className="pdp-order-price">{containerObject.atgResponse.response.response.replacementProduct.pdpPrice.basePrice}</div>
                                                                :
                                                                containerObject.atgResponse.response.response.replacementProduct.pdpPrice.retailPrice != "$0.00" ?
                                                                    <div className="prod-contract-disc d-flex align-items-start">
                                                                        <div className="prod-contract-price">
                                                                            <span className="contract-price-heading">YOUR CONTRACT PRICE</span>
                                                                            <span id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.replacementProduct?.productId}`} className="contract-price-value">{containerObject.atgResponse.response.response.replacementProduct.pdpPrice.basePrice}</span>
                                                                        </div>
                                                                        <div className="prod-retail-price">
                                                                            <span className="retail-price-heading">RETAIL PRICE</span>
                                                                            {containerObject.atgResponse.response.response.replacementProduct.pdpPrice.retailPrice != "$0.00" ?
                                                                                <span className=" pdp list-price-value">{containerObject.atgResponse.response.response.replacementProduct.pdpPrice.retailPrice}</span> : ""}
                                                                        </div>
                                                                    </div> : <div id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.replacementProduct?.productId}`} className="pdp-order-price">{containerObject.atgResponse.response.response.replacementProduct.pdpPrice.basePrice}</div>}
                                                        </>
                                                        :
                                                        containerObject.atgResponse.response.response.replacementProduct.pdpPrice && containerObject.atgResponse.response.response.replacementProduct.pdpPrice.complexPriceArray ?
                                                            <>
                                                                <div id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.replacementProduct?.productId}`} className="pdp-order-price">${containerObject.atgResponse.response.response.replacementProduct.pdpPrice.complexPriceArray[0]}</div>
                                                                {containerObject.atgResponse.response.response.replacementProduct.pdpPrice.qtyDiscountAvailable && containerObject.atgResponse.response.response.replacementProduct.pdpPrice.qtyDiscountAvailable == true ?
                                                                    <span className="fdp-item-price-label">Qty Discount Available</span>
                                                                    :
                                                                    ""
                                                                }
                                                            </>
                                                            :
                                                            containerObject.atgResponse.response.response.replacementProduct.pdpPrice.salePrice && containerObject.atgResponse.response.response.replacementProduct.pdpPrice.salePrice != "$0.00" ?
                                                                <div className="prod-contract-disc d-flex align-items-center">
                                                                    <div className="prod-contract-price">
                                                                        <span className="sale-price-value c-red">
                                                                            {containerObject.atgResponse.response.response.replacementProduct.pdpPrice.salePrice}
                                                                        </span>
                                                                    </div>
                                                                    <div className="prod-retail-price">
                                                                        <span id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.replacementProduct?.productId}`} className=" pdp list-price-value">
                                                                            {containerObject.atgResponse.response.response.replacementProduct.pdpPrice.basePrice}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.replacementProduct?.productId}`} className="pdp-order-price">{containerObject.atgResponse.response.response.replacementProduct.pdpPrice.basePrice}</div>

                                                    }
                                                </div>

                                                : ""
                                            }
                                        </>
                                    }

                                    <div class="col-12 replacementBtn cbProduct pdp-action">
                                        {containerObject.atgResponse.response.response
                                            && containerObject.atgResponse.response.response.replacementProduct
                                            && containerObject.atgResponse.response.response.replacementProduct.cbsInventoryLookUp
                                            && containerObject.atgResponse.response.response.replacementProduct.cbsInventoryLookUp.pdp_inv_message ?
                                                <div className={`form-label ${containerObject.atgResponse.response.response.replacementProduct.cbsInventoryLookUp && containerObject.atgResponse.response.response.replacementProduct.cbsInventoryLookUp.backOrdered == true ||
                                                    containerObject.atgResponse.response.response.replacementProduct.cbsInventoryLookUp.add_to_cart == false
                                                    ? "c-red" : containerObject.atgResponse.response.response.replacementProduct.cbsInventoryLookUp.bg_color == "Yellow" ? "c-green" : "c-green ftm"}`}>
                                                        ({containerObject.atgResponse.response.response.replacementProduct.cbsInventoryLookUp.pdp_inv_message})
                                                </div> :
                                                ""
                                        }
                                        <Link to={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.replacementProduct.url	 ? containerObject.atgResponse.response.response.replacementProduct.url	 : ""} class="btn btn-primary">See Replacement</Link>
                                    </div>

                                    {profileDetails && profileDetails.userTypeCheck && profileDetails.userTypeCheck.punchoutClient ?
                                        ""
                                        :
                                        isDlproductRef.current == false && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.show_price == true ?
                                            <div className="row g-0">
                                                <div className="col pdp-whislist">

                                                    {profileDetails && profileDetails.transient == true ?
                                                        <Link className="link-secondary modal-list" data-bs-target="#loginModal" data-bs-toggle="modal" data-bs-dismiss="modal" onClick={() => handleWishList(prodIdRef.current, count, containerObject?.atgResponse?.response?.response?.displayName)}>
                                                            add to wishlist
                                                        </Link> : <Link className="link-secondary modal-list" onClick={() => handleWishList(containerObject?.atgResponse?.response?.response?.replacementProduct?.productId, count, containerObject?.atgResponse?.response?.response?.replacementProduct?.displayName)} data-bs-toggle="modal" data-bs-target="#newListModalww" data-bs-dismiss="modal" >
                                                            add to wishlist
                                                        </Link>}

                                                </div>
                                            </div>
                                            :
                                            ""
                                    }
							    </div>
							</> :
							<>
                                <div className="col-12 col-md-6 order-3 mt-4">
                                    <div className="row pdp-desc">
                                        {containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.hidePrice && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.hidePrice == "true" ?
                                            <div className="col-12 cbProduct pdp-desc-price-hidePrice fw-bold">
                                                Call For Pricing
                                            </div>
                                            :
                                            <>
                                                {containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice ?

                                                    <div className="col-12 pdp-desc-price">


                                                        {profileDetails && profileDetails.userType && profileDetails.userType === 2 && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.retailPrice ?
                                                            <>

                                                                {handleRetailPrice(containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice, profileDetails.userType) == "equal" ?
                                                                    <div id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.product}`} className="pdp-order-price">{containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice}</div>
                                                                    :
                                                                    containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.retailPrice != "$0.00" ?
                                                                        <div className="prod-contract-disc d-flex align-items-start">
                                                                            <div className="prod-contract-price">
                                                                                <span className="contract-price-heading">YOUR CONTRACT PRICE</span>
                                                                                <span id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.product}`} className="contract-price-value">{containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.salePrice ? containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.salePrice :containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice ? containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice : "" }</span>
                                                                            </div>
                                                                            <div className="prod-retail-price">
                                                                                <span className="retail-price-heading">RETAIL PRICE</span>
                                                                                {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.retailPrice != "$0.00" ?
                                                                                    <span className=" pdp list-price-value">{containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.retailPrice}</span> : ""}
                                                                            </div>
                                                                        </div> : <div id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.product}`} className="pdp-order-price">{containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice}</div>}
                                                            </> :
                                                            <>
                                                                {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.priceList ?
                                                                    <table className="prod-qty-disc" >
                                                                        <tbody>
                                                                            <tr className="qty-header">
                                                                                <th className="qty-disc-label">QUANTITY</th>
                                                                                <th className="qty-disc-content">{containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePriceLable}</th>
                                                                                {profileDetails && profileDetails.userType && profileDetails.userType === 2 && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.yourRetailPriceLable ?
                                                                                    <th className="">{containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.yourRetailPriceLable}</th> : ""}
                                                                            </tr>
                                                                            {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.priceList.map((oneValues) => {
                                                                                return (<tr>
                                                                                    <td className="qty-disc-label">{oneValues && oneValues.qtyRange && oneValues.qtyRange}</td>
                                                                                    <td id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.product}`} className="qty-disc-content">{oneValues && oneValues.price && oneValues.price}</td>
                                                                                    {profileDetails && profileDetails.userType && profileDetails.userType === 2 && oneValues?.retailPrice && oneValues?.retailPrice != "$0.00" ?
                                                                                        <td className="qty-retail-content">{oneValues && oneValues.retailPrice && oneValues.retailPrice}</td> : ""}
                                                                                </tr>)
                                                                            })}
                                                                        </tbody>
                                                                    </table> :

                                                                    containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.salePrice && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.salePrice != "$0.00" ?


                                                                        <div className="prod-contract-disc d-flex align-items-center">
                                                                            <div className="prod-contract-price">
                                                                                <span className="sale-price-value c-red">
                                                                                    {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.salePrice}
                                                                                </span>
                                                                            </div>
                                                                            <div className="prod-retail-price">
                                                                                <span id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.product}`} className=" pdp list-price-value">
                                                                                    {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice}
                                                                                </span>
                                                                            </div>
                                                                        </div> :
                                                                        <div id={`ecommPrice_${containerObject?.atgResponse?.response?.response?.product}`} className="pdp-order-price">{containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdpPrice.basePrice}</div>}
                                                            </>
                                                        }</div>

                                                    : ""}</>}

                                        {containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.productHighlights ?
                                            <div className="col-12 order-3 order-md-2">
                                                <div className="pdp-desc-highlight">
                                                    <span className="pdp-desc-highlight-title">
                                                        Product Highlights
                                                    </span>
                                                    <div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.standardResult.pdpOrderResult.productHighlights }}></div>
                                                </div>
                                            </div> : ""}


                                        <div className="col-12 order-2 order-md-3">
                                            <div className="pdp-desc-restrictions">


                                                {containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult
                                                    && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdp_ship_account_restriction_info ?
                                                    <p onClick={() => scrollToView("specification")} className="pdp-scroll-to icon-content hyperLinkStyle">
                                                        <i className="bi bi-exclamation-circle-fill"></i>
                                                        <span className="icon-text" style={{ "font-size": ".875rem" }}>
                                                            {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.pdp_ship_account_restriction_info}
                                                        </span>
                                                    </p> : ""}
                                            </div>
                                            <div className="pdp-desc-actiohandleAddToCartn">
                                                {/* restriction add to cart  */}

                                                {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.add_to_cart === false ?
                                                    <div className="row g-0 pdp-availability-msg">
                                                        <div className="col">

                                                            <p dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.pdp_inv_message }} ></p>
                                                        </div>
                                                    </div> :
                                                    <div className="row g-0 pdp-desc-addToCart">
                                                        <form onSubmit={handleAddToCart} method="post" name="addTocart" id="addToCart" className="col addToCart" >
                                                            <div className="row g-0">
                                                                <div className="col">
                                                                    <div>
                                                                        <label for="quantity" className="form-label">Quantity</label>
                                                                    </div>
                                                                    <div className="input-group c-input-group">
                                                                        <button type="button" className="button-minus" data-field="quantity" aria-label="decreament the quantity" onClick={() => Decrement()}>
                                                                            <i className="bi bi-dash"></i>
                                                                        </button>
                                                                        <input type="hidden" name="productId" value={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.schemaJson && containerObject.atgResponse.response.response.schemaJson.schemaJson && containerObject.atgResponse.response.response.schemaJson.schemaJson.sku ? containerObject.atgResponse.response.response.schemaJson.schemaJson.sku : ""} />
                                                                        <label for="cbQuantity" className="d-none" />
                                                                        <input id="cbQuantity" maxlength="3" max="999" name="quantity" type="text" value={count ? count : ""} className="quantities quantity-field form-control" onChange={handleChangeCount} />
                                                                        <button type="button" className="button-plus" data-field="quantity" aria-label="increament the quantity" onClick={() => Increment()}>
                                                                            <i className="bi bi-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                <div className="col col-md-7 col-lg-8 cbProduct pdp-action">
                                                                    { backOrderQtyRef.current > 0 ?
                                                                            <div className={`form-label pdp-status-msg c-red`}>Quantity Available: {backOrderQtyRef.current}</div>
                                                                        :
                                                                        <>
                                                                            {containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isDLProduct == true ? <div className="form-label pt-3 mt-1" /> : <>
                                                                                {containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.pdpOrderResult
                                                                                    && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.pdp_inv_message ?

                                                                                    <div className={`form-label pdp-status-msg ${containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.backOrdered == true ||
                                                                                        containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.add_to_cart == false
                                                                                        ? "c-red" : containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.bg_color == "Yellow" ? "c-green" : "c-green ftm"}`}>({containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.pdp_inv_message})</div> : ""}
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.add_to_cart == true ?

                                                                        <input type="submit" name="submit" className={`btn ${ backOrderQtyRef.current > 0 &&  count > backOrderQtyRef.current ? "btn-disable" : "btn-primary"}`} value={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isDLProduct == false ? "Add to Cart" : "Order Now"} /> : ""}
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>}

                                                {profileDetails && profileDetails.userTypeCheck && profileDetails.userTypeCheck.punchoutClient ? "" :
                                                    isDlproductRef.current == false && containerObject.atgResponse.response.response.standardResult.pdpOrderResult.cbsInventoryLookUp.show_price == true ?
                                                        <div className="row g-0">
                                                            <div className="col pdp-whislist">

                                                                {profileDetails && profileDetails.transient == true ?
                                                                    <Link className="link-secondary modal-list" data-bs-target="#loginModal" data-bs-toggle="modal" data-bs-dismiss="modal" onClick={() => handleWishList(prodIdRef.current, count, containerObject?.atgResponse?.response?.response?.displayName)}>
                                                                        add to wishlist
                                                                    </Link> : <Link className="link-secondary modal-list" onClick={() => handleWishList(prodIdRef.current, count, containerObject?.atgResponse?.response?.response?.displayName)} data-bs-toggle="modal" data-bs-target="#newListModalww" data-bs-dismiss="modal" >
                                                                        add to wishlist
                                                                    </Link>}

                                                            </div>
                                                        </div> : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
							</>}
						</div>
					</>
					: ""}

				{/* CBS product ended here */}

				{/* CBS family varient started here */}

				{containerObject?.atgResponse?.response?.response?.familyProduct?.galleryJson?.prodType == "CBS Family" ?
					<>

						{/* <div dangerouslySetInnerHTML={{
							__html: `<script type="application/ld+json">
							${containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.schemaJson && containerObject.atgResponse.response.response.familyProduct.schemaJson.schemaJson}
						</script>`}}></div> */}
						<div id="body" className={`row ${screenWidthRef.current < 810 ? "p-0 m-0 g-0" : ""}`}>

							<div className="col-12 order-2 order-md-1  " style={{ "min-height": "118px"}}>

								<div className="row" id="prod-sticky-nav">
									<div className="col prod-nav-title">
										<h1 dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : "" }} />
									</div>
									<div className="col-12 pdp-nav" id="pdp-nav">
										<ul className="row prod-nav-group list-unstyled g-0">
											<li className="col-3 prod-nav-item hide-on-sticky block d-md-none">
												<div className="m0">
													<span className="fwb ftms">{containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList.length > 0 ? containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList.length : ""} Items</span>
												</div>
											</li>
											<li className="col-4 prod-nav-item hide-on-sticky m-0">
												<div><span className="fwb ftms">Item #:</span> <span id="pdp-skuId">{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : ""}</span></div>
											</li>
											<li className="col-5 prod-nav-item hide-on-sticky" >
												{prodIdRef.current ? isDlproductRef.current == false ?
													<div data-bv-show="rating_summary" data-bv-product-id={prodIdRef.current} ></div> : "" : ""}

											</li>
											<li className="col prod-nav-item bg-light-grey">
												<p className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("description")}>
													Description
												</p>
											</li>
											<li className="col prod-nav-item bg-light-grey">
												<p className="pdp-scroll-to hyperLinkStyle"
													onClick={() => scrollToView("specification")}
												>
													Specifications
												</p>
											</li>
											{isDlproductRef.current == false ? <>
												<li className="col prod-nav-item bg-light-grey">
													<p id="scrollReviewId" className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("reviews")}>

														Reviews
													</p>
												</li>
												{productTypeRef.current != "CBS Family" ?
													<li className="col prod-nav-item bg-light-grey">
														<p className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("qAndA")}>

															Q&amp;A
														</p>
													</li> : ""}</> : ""}
										</ul>
										{productTypeRef.current ?handleReviewScroll():""}
									</div>
								</div>
							</div>
							<div className="col-12 col-md-4 col-lg-3 order-1 order-md-2 py-4 fdp-gallery">
								<div id="pdp-gallery" className="carousel carousel-dark slide" data-bs-ride="false" data-bs-interval="false">
									<div className="carousel-inner active" onClick={() => handleProductImage(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.largeImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.largeImg : containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg : "")}>
										<div >

											{screenWidthRef.current > 810 ?
												<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "220px", "height": "220px" }} className="printShowImage" src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg : containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg : "")} />
												: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "220px", "height": "220px" }} className="printShowImage" src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg : containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg : "")} />}

											{/* <Zoom
													img={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg : containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg : "")}
													zoomScale={3}
													width={screenWidthRef.current > 810 ? 220 : ""}
													height={220}

													className="imagepointer replaceImage_1 printHideImage"
												/>  */}
											<div id="zoomImage_1" className="zoom cbFamilyZoom printHideImage " imageurl={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.largeImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.largeImg : containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg : "")}>
												{screenWidthRef.current > 810 ?
													<img id="1" className="img-fluid new-9" height={220} alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} fetchpriority="high" 
													src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg : containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg : "")} 
													srcSet={`${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.familyProduct?.galleryJson?.smallImg)} 480w, 
															${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.familyProduct?.galleryJson?.detailImg)} 1024w, 
															${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.familyProduct?.galleryJson?.largeImg)} 1200w`}
															sizes="(min-width: 480px) 100vw,
															(min-width: 1024px) 100vw,
															(min-width: 1200px) 100vw,
															100vw"	
															onError={handleReplaceLargeImageForFamily} />
													: <img id="1" className="img-fluid new-10" height={220} alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} 
													src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.galleryJson && containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.detailImg : containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg ? containerObject.atgResponse.response.response.familyProduct.galleryJson.mediumImg : "")} 
													srcSet={`${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.familyProduct?.galleryJson?.smallImg)} 480w, 
															${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.familyProduct?.galleryJson?.detailImg)} 1024w, 
															${domainNameRef.current.concat(containerObject?.atgResponse?.response?.response?.familyProduct?.galleryJson?.largeImg)} 1200w`}
															sizes="(min-width: 480px) 100vw,
																(min-width: 1024px) 100vw,
																(min-width: 1200px) 100vw,
																100vw"	
													onError={handleReplaceLargeImageForFamily} />}
											</div>


											{/* {handleZoomImage() == true ? "" : ""} */}
										</div>
									</div>
								</div>
							</div>

							<div className="col-12 col-md-8 col-lg-9 order-3 py-4">
								<div className="row pdp-desc">
									{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyItem && containerObject.atgResponse.response.response.familyProduct.familyItem.hidePrice && containerObject.atgResponse.response.response.familyProduct.familyItem.hidePrice == "true" ?
										<span className="pdp-order-price">
											Call For Pricing
										</span>
										:
										<>
											{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyPrice && containerObject.atgResponse.response.response.familyProduct.familyPrice.itemPrice ?

												profileDetails && profileDetails.userType && profileDetails.userType === 2 && containerObject.atgResponse.response.response.familyProduct.familyPrice && containerObject.atgResponse.response.response.familyProduct.familyPrice.retailPriceInited == true &&
													containerObject.atgResponse.response.response.familyProduct.familyPrice.itemPrice != containerObject.atgResponse.response.response.familyProduct.familyPrice.retailPrice  && containerObject.atgResponse.response.response.familyProduct.familyPrice.retailPrice != "$0.00 - $0.00"?
													<div className="col-12 fdp-qty-disc">
														<div className="prod-contract-disc d-flex align-items-start">
															<div className="prod-contract-price">
																<span className="contract-price-heading">YOUR CONTRACT PRICE</span>
																<span id="ecommFamilyPrice" className="contract-price-value">{containerObject.atgResponse.response.response.familyProduct.familyPrice.itemPrice}</span>
																{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyPrice && containerObject.atgResponse.response.response.familyProduct.familyPrice.qtyDiscount && containerObject.atgResponse.response.response.familyProduct.familyPrice.qtyDiscount == true ?
																	<span className="d-block fst-italic">Quantity Discount Available</span> : ""}
															</div>
															<div className="prod-retail-price">
																<span className="retail-price-heading">RETAIL PRICE</span>
																<span className=" pdp list-price-value">{containerObject.atgResponse.response.response.familyProduct.familyPrice.retailPrice}</span>
															</div>

														</div>
													</div> :
													<>
														<div className="col-12 fdp-qty-disc">
															<h4 className="mb-0" >
																<b id="ecommFamilyPrice">{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyPrice && containerObject.atgResponse.response.response.familyProduct.familyPrice.itemPrice && containerObject.atgResponse.response.response.familyProduct.familyPrice.itemPrice != "null - null" ? containerObject.atgResponse.response.response.familyProduct.familyPrice.itemPrice : ""}
																</b>
															</h4>
															{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyPrice && containerObject.atgResponse.response.response.familyProduct.familyPrice.qtyDiscount && containerObject.atgResponse.response.response.familyProduct.familyPrice.qtyDiscount == true ?
																<span className="d-block fst-italic">Quantity Discount Available</span> : ""}
														</div>
													</> : 
													// <div className="col-12 fdp-qty-disc"><div><span className="pdp-order-price" id="ecommFamilyPrice">0.00 - 0.00</span></div></div>
											""
											}
										</>}
									{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.shortDescription ? <div className="col-12 d-none d-md-block" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.shortDescription }} /> : ""}


								</div>
							</div>
						</div>
						<section className="fdp-items">
							<div className="col-md-12 fdp__items">
								{containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList.length > 0 ?
									<h2 className="h2 d-none d-md-block">{containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList.length > 0 ? containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList.length : ""} Product Options</h2> : ""}
								<ul className="col-12 list-unstyled">
									{containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyItem && containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList && containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductList.map((oneItems) => {
										return (<>
											{oneItems.price && oneItems.price != "0.00" ? <li className="fdp-item">
												<div className="row align-items-center">
													<div className={`col-12 ${oneItems.replacementProduct ? "col-lg-6" : "col-lg-8"}`}>
														<div className="row align-items-center g-0 fdp-item-desc">
															<div className="col-12 col-md-8 d-flex">
																<div className="fdp-item-img">
																	<Link to={oneItems.familyProductUrl ? oneItems.familyProductUrl : ""}>
																		{screenWidthRef.current > 810 ?
																			<img loading="lazy" style={{ "height": "90px" }} alt={oneItems.famProductName ? oneItems.famProductName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneItems.imageURL ? oneItems.imageURL : "")} />
																			: <img style={{ "height": "90px" }} alt={oneItems.famProductName ? oneItems.famProductName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneItems.imageURL ? oneItems.imageURL : "")} />}
																	</Link>
																</div>
																<div >
																	<Link className="fdp-item-title" to={oneItems.familyProductUrl ? oneItems.familyProductUrl : ""} dangerouslySetInnerHTML={{ __html: oneItems.famProductName ? oneItems.famProductName : "" }}></Link>

																	{oneItems && oneItems.reviewURLAverage ?
																		screenWidthRef.current > 810 ?
																			<img loading="lazy" className="fdp-item-rating" alt="ratings" src={`/images/stars/50/rating-${oneItems.reviewURLAverage}_50.png`} /> :
																			<img className="fdp-item-rating" alt="ratings" src={`/images/stars/50/rating-${oneItems.reviewURLAverage}_50.png`} /> : ""
																	}


																	<div className="fdp-item-status">
																		<span>#{oneItems.skuId ? oneItems.skuId : ""}</span>

																		{oneItems.replacementProduct ?
																		    <span class="col c-red fw-bold">(Discontinued)</span>
																		    :
																		    oneItems.cbsInventoryLookUp.pdp_inv_message ?
                                                                                <>
                                                                                    <span className={`col ${oneItems.cbsInventoryLookUp.backOrdered == true || oneItems.cbsInventoryLookUp.add_to_cart == false ? "c-red" : oneItems.cbsInventoryLookUp.bg_color == "Yellow" ? "c-green " : "c-green ftm"} `} dangerouslySetInnerHTML={{ __html: `(${oneItems.cbsInventoryLookUp.pdp_inv_message})` }}></span>
                                                                                </>
                                                                            : ""
																		}
																	</div>
																</div>
															</div>

															{oneItems.replacementProduct ?
															    ""
															    :
															    containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyItem && containerObject.atgResponse.response.response.familyProduct.familyItem.hidePrice && containerObject.atgResponse.response.response.familyProduct.familyItem.hidePrice == "true" ?
                                                                    <div className="col fdp-item-price">
                                                                        <span className="fdp-item-price-val">
                                                                            Call For Pricing
                                                                        </span>
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        {oneItems.cbsInventoryLookUp && oneItems.cbsInventoryLookUp.show_price == true ?
																		
                                                                            <div className="col fdp-item-price">
																				{oneItems?.familyListPrice?.salePrice && oneItems?.familyListPrice?.salePrice!= "$0.00" ?
																
																				<>
																					<span className="fdp-item-price-val c-red">
																						{oneItems?.familyListPrice?.salePrice}
																					</span>
																					<span id={`ecommPrice_${oneItems.skuId}`} className="fdp-item-reg-price">
																						{oneItems?.familyListPrice?.basePrice}
																					</span>
																				</>
																		:<>
                                                                                <span id={`ecommPrice_${oneItems.skuId}`} className="fdp-item-price-val">{oneItems.price && oneItems.price}</span>
                                                                                {profileDetails && profileDetails.userType && profileDetails.userType === 2 && oneItems.familyListPrice && oneItems.familyListPrice.retailPrice != oneItems.price && oneItems.familyListPrice.retailPrice != "$0.00" ?
                                                                                    <span className="fdp-item-price-label">Retail&nbsp;{oneItems?.familyListPrice?.retailPrice ? oneItems.familyListPrice.retailPrice : oneItems?.familyListPrice?.priceList[0]?.retailPrice}</span>
                                                                                    : ""}
                                                                                {/* here we need to handle qtyDiscountAvailable FAM_513301C.pr */}
                                                                                {oneItems.familyListPrice && oneItems.familyListPrice.qtyDiscountAvailable && oneItems.familyListPrice.qtyDiscountAvailable == true ?
                                                                                    <span className="fdp-item-price-label">Quantity Discount Available</span>
                                                                                    : ""}
                                                                            </>}</div>
                                                                        : ""}
                                                                    </>
															}
														</div>
													</div>
													{oneItems.replacementProduct ?
													    <div class="col-12 col-lg-6">
                                                            <div class="row align-items-center g-0 fdp-item-desc replacementTile restricted-item-row lfpdp">
                                                                <div class="col-12 col-md-8 d-flex">
                                                                    <div class="fdp-item-img">
                                                                        <Link to={oneItems.replacementProduct.url ? oneItems.replacementProduct.url : ""}>
                                                                            {screenWidthRef.current > 810 ?
                                                                                <img loading="lazy" style={{ "height": "90px" }} alt={oneItems.replacementProduct.displayName ? oneItems.replacementProduct.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneItems.replacementProduct.imageURL ? oneItems.replacementProduct.imageURL : "")} />
                                                                                : <img style={{ "height": "90px" }} alt={oneItems.replacementProduct.displayName ? oneItems.replacementProduct.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneItems.replacementProduct.imageURL ? oneItems.replacementProduct.imageURL : "")} />}
                                                                        </Link>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span class="c-red fw-bold">Replacement</span>
                                                                        <Link className="fdp-item-title" to={oneItems.replacementProduct.url ? oneItems.replacementProduct.url : ""} dangerouslySetInnerHTML={{ __html: oneItems.replacementProduct.displayName ? oneItems.replacementProduct.displayName : "" }}></Link>
                                                                        <div class="fdp-item-status">
                                                                            <span>#{oneItems.replacementProduct.productId ? oneItems.replacementProduct.productId : ""}</span>
                                                                        </div>

                                                                        {containerObject.atgResponse.response.response
                                                                            && containerObject.atgResponse.response.response.familyProduct
                                                                            && containerObject.atgResponse.response.response.familyProduct.familyItem
                                                                            && containerObject.atgResponse.response.response.familyProduct.familyItem.hidePrice
                                                                            && containerObject.atgResponse.response.response.familyProduct.familyItem.hidePrice == "true" ?
                                                                            <div className="col-12 cbProduct pdp-desc-price-hidePrice fw-bold">
                                                                                Call For Pricing
                                                                            </div>
                                                                            :
                                                                            <>
                                                                                {oneItems.replacementProduct
                                                                                    && oneItems.replacementProduct.pdpPrice
                                                                                    && oneItems.replacementProduct.pdpPrice.basePrice ?
                                                                                    <div className="pdp-desc-price">
                                                                                        {profileDetails && profileDetails.userType && profileDetails.userType === 2 && oneItems.replacementProduct.pdpPrice.retailPrice ?
                                                                                            <>
                                                                                                {handleRetailPrice(oneItems.replacementProduct.pdpPrice, profileDetails.userType) == "equal" ?
                                                                                                    <div id={`ecommPrice_${oneItems?.replacementProduct?.productId}`} className="fdp-item-price-val">{oneItems.replacementProduct.pdpPrice.basePrice}</div>
                                                                                                    :
                                                                                                    oneItems.replacementProduct.pdpPrice.retailPrice != "$0.00" ?
                                                                                                        <div className="prod-contract-disc d-flex align-items-start">
                                                                                                            <div className="col fdp-item-price">
                                                                                                                <span id={`ecommPrice_${oneItems?.replacementProduct?.productId}`} className="fdp-item-price-val">{oneItems.replacementProduct.pdpPrice.basePrice}</span>
                                                                                                                <span className="fdp-item-price-label">Retail&nbsp;{oneItems.replacementProduct.pdpPrice.retailPrice}</span>
                                                                                                            </div>
                                                                                                        </div> : <div id={`ecommPrice_${oneItems?.replacementProduct?.productId}`} className="fdp-item-price-val">{oneItems.replacementProduct.pdpPrice.basePrice}</div>}
                                                                                            </>
                                                                                            :
                                                                                            oneItems.replacementProduct.pdpPrice && oneItems.replacementProduct.pdpPrice.complexPriceArray ?
                                                                                                <>
                                                                                                    <div id={`ecommPrice_${oneItems?.replacementProduct?.productId}`} className="fdp-item-price-val">${oneItems.replacementProduct.pdpPrice.complexPriceArray[0]}</div>
                                                                                                    {oneItems.replacementProduct.pdpPrice.qtyDiscountAvailable && oneItems.replacementProduct.pdpPrice.qtyDiscountAvailable == true ?
                                                                                                        <span className="fdp-item-price-label">Qty Discount Available</span>
                                                                                                        :
                                                                                                        ""
                                                                                                    }
                                                                                                </>
                                                                                                :
                                                                                                oneItems.replacementProduct.pdpPrice.salePrice && oneItems.replacementProduct.pdpPrice.salePrice != "$0.00" ?
                                                                                                    <div className="prod-contract-disc d-flex align-items-center">
                                                                                                        <div className="fdp-item-price">
                                                                                                            <span className="sale-price-value c-red">
                                                                                                                {oneItems.replacementProduct.pdpPrice.salePrice}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div className="fdp-item-price">
                                                                                                            <span id={`ecommPrice_${oneItems?.replacementProduct?.productId}`} className=" pdp list-price-value">
                                                                                                                {oneItems.replacementProduct.pdpPrice.basePrice}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    :
                                                                                                    <div id={`ecommPrice_${oneItems?.replacementProduct?.productId}`} className="fdp-item-price-val">{oneItems.replacementProduct.pdpPrice.basePrice}</div>

                                                                                        }
                                                                                    </div>

                                                                                    : ""
                                                                                }
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="col-12 col-lg-4">
                                                            <div className="row fdp-item-action">
                                                                <div className="col offset-md-6 offset-lg-0">
                                                                    <div className="d-flex g-0 pdp-desc-addToCart">
                                                                        {oneItems.cbsInventoryLookUp.add_to_cart == false ? <div className="col fdp-learn-more">
                                                                            <Link title="learn more" to={oneItems.familyProductUrl ? oneItems.familyProductUrl : ""} className="btn-grey">Learn More</Link>
                                                                        </div> :
                                                                            <form method="post" name="addTocart1" action="" id="addToCart211460" className="row addToCart" onSubmit={handleAddToCart}>
                                                                                <div className="d-md-none"><label for="quantity" className="fwb mb-1">Quantity</label></div>
                                                                                <div className=" col input-group c-input-group">

                                                                                    <button type="button" className="button-minus" data-field="quantity" aria-label="decreament the quantity" onClick={() => handleDecrement(oneItems.skuId)}>
                                                                                        <i className="bi bi-dash"></i>
                                                                                    </button>
                                                                                    <input type="hidden" name="productId" value={oneItems.skuId} />
                                                                                    <label for={oneItems.skuId} className="d-none" />
                                                                                    <input maxlength="3" max="999" name="quantity" id={oneItems.skuId} type="text" value={productcountref.current[oneItems.skuId] ? productcountref.current[oneItems.skuId] : ""} className="quantities form-control quantity-field" onChange={handleChangeCountForVarient} />
                                                                                    <button type="button" className="button-plus" data-field="quantity" aria-label="increament the quantity" onClick={() => handleIncrement(oneItems.skuId)}>
                                                                                        <i className="bi bi-plus"></i>
                                                                                    </button>
                                                                                </div>


                                                                                <div className=" col pdp-action">

                                                                                    <input type="submit" name="submit" className="btn btn-primary m-0" value={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isDLProduct == false ? "Add to Cart" : "Order Now"} />
                                                                                </div>

                                                                            </form>}
                                                                    </div>
                                                                </div>
                                                                {oneItems.cbsInventoryLookUp.add_to_cart == false ? "" :
                                                                    profileDetails && profileDetails.userTypeCheck && profileDetails.userTypeCheck.punchoutClient ? "" :
                                                                        <div className="col-12 fdp-whishlist">
                                                                            {profileDetails && profileDetails.transient == true ?
                                                                                <Link className="link-secondary" data-bs-target="#loginModal" data-bs-toggle="modal" data-bs-dismiss="modal" onClick={() => handleWishList(oneItems.skuId, productcountref.current[oneItems.skuId], oneItems.famProductName)}>
                                                                                    add to wishlist
                                                                                </Link> : <Link className="link-secondary" data-bs-toggle="modal" data-bs-target="#newListModalww" data-bs-dismiss="modal" onClick={() => handleWishList(oneItems.skuId, productcountref.current[oneItems.skuId], oneItems.famProductName)}>
                                                                                    add to wishlist
                                                                                </Link>}
                                                                        </div>}
                                                            </div>
                                                        </div>

													}
												</div>
											</li> : ""}

										</>
										)
									})
									}
								</ul>
							</div>
						</section>
					</>
					: ""}


				{/* CBS family varient ended here */}

				{/* CBS family tabs started here */}
				{containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.galleryJsonResult?.prodType == "CBS Product" && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isproductGrouping == true ?
					<>

						{/* <div dangerouslySetInnerHTML={{
							__html: `<script type="application/ld+json">
							${containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.schemaJson && containerObject.atgResponse.response.response.familyVariyantProductDetails.schemaJson.schemaJson}
						</script>`}}></div> */}
						<div id="body" className={`row ${screenWidthRef.current < 810 ? "p-0 m-0 g-0" : ""}`}>
							<div className="col-12 order-2 order-md-1 " style={{ "min-height": "118px"}}>

								<div className="row " id="prod-sticky-nav">
									<div className="col prod-nav-title">
										<h1 dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantDisplayName ? containerObject.atgResponse.response.response.familyVariyantDisplayName : "" }} />
									</div>
									<div className="col-12 pdp-nav" id="pdp-nav">
										<ul className="row prod-nav-group list-unstyled g-0">
											<li className="col-6 prod-nav-item hide-on-sticky">

												<div className="m0"><span className="fwb ftms">Item #:</span> <span id="pdp-skuId">{selectSkuResultRef.current ? selectSkuResultRef.current : containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : ""}</span></div>
											</li>
											<li className="col-6 prod-nav-item hide-on-sticky" >
												{prodIdRef.current ? isDlproductRef.current == false ?
													<div data-bv-show="rating_summary" data-bv-product-id={containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.familyProductId} ></div> : "" : ""}
											</li>
											<li className="col prod-nav-item bg-light-grey">
												<p className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("description")}>
													Description
												</p>
											</li>
											<li className="col prod-nav-item bg-light-grey">
												<p className="pdp-scroll-to hyperLinkStyle"
													onClick={() => scrollToView("specification")}
												>
													Specifications
												</p>
											</li>
											{isDlproductRef.current == false ? <>
												<li className="col prod-nav-item bg-light-grey">
													<p id="scrollReviewId" className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("reviews")}>

														Reviews
													</p>
												</li>
												{productTypeRef.current != "CBS Family" ?
													<li className="col prod-nav-item bg-light-grey">
														<p className="pdp-scroll-to hyperLinkStyle" onClick={() => scrollToView("qAndA")}>

															Q&amp;A
														</p>
													</li> : ""}</> : ""}
										</ul>
										{productTypeRef.current ?handleReviewScroll():""}
									</div>
								</div>
							</div>

							<div className="col-12 col-md-6 order-1 order-md-2 py-4">
								<div id="pdp-gallery" className="carousel carousel-dark slide" data-bs-ride="false" data-bs-interval="false">
									<div className="carousel-inner pdp-gallery-slides">

										{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {
											return (<>
												{oneVarient && oneVarient.variantsMap && oneVarient.skuId === (selectSkuResultRef.current ? selectSkuResultRef.current : containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.selectedSku?.skuId)?
													<>
														{oneVarient.images.map((oneImages, index) => {
															return (<>
																<div className={`carousel-item ${index == 0 ? "active" : ""} modalImage_${index}"`} id={`modal-image${index}`} onClick={() => handleProductImage(oneImages.large)} >
																	{screenWidthRef.current > 810 ?
																		<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantDisplayName ? containerObject.atgResponse.response.response.familyVariyantDisplayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage new-11" src={domainNameRef.current.concat(oneImages.medium)} />
																		: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantDisplayName ? containerObject.atgResponse.response.response.familyVariyantDisplayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage new-12" src={domainNameRef.current.concat(oneImages.medium)} />}
																	{/*	<Zoom
																			img={domainNameRef.current.concat(oneImages.medium)}
																			zoomScale={2}
																			width={screenWidthRef.current > 810 ? 400 : 300}
																			height={screenWidthRef.current > 810 ? 400 : 300}

																			className={`imagepointer replaceImage_${index} printHideImage`}
																		/> */}

																	<div id={`zoomImage_${index}`} className="zoom cbProductZoom printHideImage" imageurl={domainNameRef.current.concat(oneImages.large)}>
																		{screenWidthRef.current > 810 ?
																			<img className="new-13" width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} id={index} alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} fetchpriority="high" 
																			 src={domainNameRef.current.concat(oneImages.medium)} 
																			srcSet={`${domainNameRef.current.concat(oneImages.medium)} 1024w, 
																			${domainNameRef.current.concat(oneImages.large)} 1200w`} 
																			sizes="(min-width: 480px) 100vw,
																			(min-width: 1024px) 100vw,
																			(min-width: 1200px) 100vw,
																			100vw"	
																			onError={handleReplaceLargeImage} />
																			: <img className="new-14" width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} id={index} alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} 
																			src={domainNameRef.current.concat(oneImages.medium)} 
																			srcSet={`${domainNameRef.current.concat(oneImages.medium)} 1024w,
																			 ${domainNameRef.current.concat(oneImages.large)} 1200w`} 
																			 sizes="(min-width: 480px) 100vw,
																			 (min-width: 1024px) 100vw,
																			 (min-width: 1200px) 100vw,
																			 100vw"																				 onError={handleReplaceLargeImage} />}
																	</div>

																	{/* {handleZoomImage() == true ? "" : ""} */}
																</div>

															</>)
														})}

														{oneVarient.video.length > 0 && oneVarient.video.map((oneVideo, index) => {
															return (<>
																<div className={`carousel-item`}>
																	<ReactPlayerLoader
																		id="playlist-player-id"
																		playerId="xlAiVNpci"
																		accountId="17907428001"
																		videoId={oneVideo.videoUrl}
																		onFailure={onFailure}
																		onSuccess={onSuccess}
																		options={{ responsive: true, autoplay: false, muted: false }}
																	/>
																</div>
															</>)
														})}

													</> : ""}</>)
										})}

									</div>
									{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {

										return (<>
											{oneVarient && oneVarient.variantsMap && oneVarient.skuId === (selectSkuResultRef.current? selectSkuResultRef.current:containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.selectedSku?.skuId) ?

												<>
													{handleShowThumbNailProduct(oneVarient.images.length, oneVarient.video.length) > 1 ? <>
														<button className="carousel-control-prev" type="button" data-bs-target="#pdp-gallery" data-bs-slide="prev">
															<span className="carousel-control-prev-icon" aria-hidden="true"></span>
															<span className="visually-hidden">Previous</span>
														</button>
														<button className="carousel-control-next" type="button" data-bs-target="#pdp-gallery" data-bs-slide="next">
															<span className="carousel-control-next-icon" aria-hidden="true"></span>
															<span className="visually-hidden">Next</span>
														</button></> : ""}</> : ""}</>)
									})}
									<div className="carousel-indicators pdp-gallery-thumbnails">


										{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {

											return (<>
												{oneVarient && oneVarient.variantsMap && oneVarient.skuId === (selectSkuResultRef.current? selectSkuResultRef.current:containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.selectedSku?.skuId) ?

													<>
														{handleShowThumbNailProduct(oneVarient.images.length, oneVarient.video.length) > 1 ? <>
															{oneVarient.images.map((oneImages, index) => {

																return (<>

																	<button type="button" data-bs-target="#pdp-gallery" data-bs-slide-to={index} className={index == 0 ? "active" : ""} aria-label={`Slide ${index + 1}`} aria-current="true">
																		{screenWidthRef.current > 810 ?
																			<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantDisplayName ? containerObject.atgResponse.response.response.familyVariyantDisplayName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneImages.thumbNail)} />
																			: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantDisplayName ? containerObject.atgResponse.response.response.familyVariyantDisplayName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneImages.thumbNail)} />}
																	</button>
																</>)
															})}

															{oneVarient.video.map((oneVideo, index) => {
																return (<>


																	<button className="video-thumb" type="button" data-bs-target="#pdp-gallery" data-bs-slide-to={oneVarient.images.length + index} aria-label={`Slide ${oneVarient.images.length + index}`}>
																		{screenWidthRef.current > 810 ?
																			<img fetchpriority="high" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantDisplayName ? containerObject.atgResponse.response.response.familyVariyantDisplayName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneVideo.thumbNail)} />
																			: <img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantDisplayName ? containerObject.atgResponse.response.response.familyVariyantDisplayName : ""} onError={replaceImage} src={domainNameRef.current.concat(oneVideo.thumbNail)} />}
																		<div className="video-thumb-overlay">
																			<i className="bi bi-play-circle"></i>
																			<span>Video</span>
																		</div>
																	</button>
																</>)
															})}</> : ""}

													</> : ""}</>)
										})}
									</div>
								</div>
							</div>

							<div className="col-12 col-md-6 order-3 py-4">
								<div className="row pdp-desc">
									{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.hidePrice && containerObject.atgResponse.response.response.familyVariyantProductDetails.hidePrice == "true" ?
										<div className="col-12 cbsFamilyTabs pdp-desc-price-hidePrice fw-bold">
											Call For Pricing
										</div>
										:
										<>{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {
											return (<>
												{oneVarient && oneVarient.inventoryStatus != "replacement" && oneVarient.variantsMap && oneVarient.skuId === (selectSkuResultRef.current? selectSkuResultRef.current:containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.selectedSku?.skuId) ?
													<>
														<div className="col-12 pdp-desc-price p-md-0">
															{oneVarient.priceInfo && oneVarient.priceInfo.complexPrice && oneVarient.priceInfo.complexPrice ?
																<table className="prod-qty-disc" >
																	<tbody>
																		<tr className="qty-header">
																			<th className="qty-disc-label">{oneVarient.priceInfo.qtyLabel}</th>
																			<th className="qty-disc-content">{oneVarient.priceInfo.baseLabel}</th>
																			{oneVarient.priceInfo.retailLabel && oneVarient.priceInfo.retailLabel != null ?
																				<th className="">{oneVarient.priceInfo.retailLabel}</th> : ""}
																		</tr>
																		{oneVarient && oneVarient.priceInfo && oneVarient.priceInfo.complexPrice && oneVarient.priceInfo.complexPrice.map((oneValues) => {
																			return (<tr>
																				<td className="qty-disc-label">{oneValues && oneValues.qtyRangePrice[0] && oneValues.qtyRangePrice[0]}</td>
																				<td id={`ecommPrice_${selectSkuResultRef.current}`} className="qty-disc-content">{oneValues && oneValues.qtyRangePrice[1] && oneValues.qtyRangePrice[1]}</td>
																				{oneVarient.priceInfo.retailLabel && oneVarient.priceInfo.retailLabel != null ?
																					<td className="qty-retail-content">{oneValues && oneValues.qtyRangePrice[2] && oneValues.qtyRangePrice[2]}</td> : ""}
																			</tr>)
																		})}
																	</tbody>
																</table> : oneVarient.priceInfo && oneVarient.priceInfo.regularPrice && oneVarient.priceInfo.regularPrice.length > 0 ? <>


																	{oneVarient.priceInfo.retailLabel && oneVarient.priceInfo.retailLabel != null ?
																		<div className="prod-contract-disc d-flex align-items-start">
																			<div className="prod-contract-price">
																				<span className="contract-price-heading">{oneVarient.priceInfo.baseLabel}</span>
																				<span id={`ecommPrice_${selectSkuResultRef.current}`} className="contract-price-value">{oneVarient.priceInfo.regularPrice[0]}</span>
																			</div>
																			<div className="prod-retail-price">
																				<span className="retail-price-heading">{oneVarient.priceInfo.retailLabel}</span>
																				<span className=" pdp list-price-value">{oneVarient.priceInfo.regularPrice[1]}</span>
																			</div>
																		</div>
																		:
																		oneVarient.priceInfo.regularPrice.length == 1 ?
																			<div id={`ecommPrice_${selectSkuResultRef.current}`} className="pdp-order-price">{oneVarient.priceInfo.regularPrice}</div> :


																			<div className="prod-contract-disc d-flex align-items-center">
																				<div className="prod-contract-price">
																					<span className="sale-price-value c-red">
																						{oneVarient.priceInfo.regularPrice[0]}
																					</span>
																				</div>
																				<div className="prod-retail-price">
																					<span className=" pdp list-price-value">
																						{oneVarient.priceInfo.regularPrice[1]}
																					</span>
																				</div>
																			</div>
																	}



																</> : ""}
														</div>

													</> : ""}
											</>)
										})}</>}
									{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productHighlights ?
											<div className="col-12 order-3 order-md-2">
												<div className="pdp-desc-highlight" style={{ "margin-left": "-10px" }}>
													<span className="pdp-desc-highlight-title">
														Product Highlights
													</span>
													<div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.familyVariyantProductDetails.productHighlights}}></div>
												</div>
										    </div> : ""}
									
									<div className="col-12 order-2 order-md-3 p-md-0">
										{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.allVariants && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.allVariants && containerObject.atgResponse.response.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.allVariants?.map((oneVarient) => {
											return (<>
												<div id="pdp-variants">
													<div className="pdp-variant-options">
														<div className="variant-heading">
															<label>{oneVarient.groupName}</label>
														</div>
														<ul className="variant-items">
															{oneVarient.values.map((oneSize) => {
																return (<li className="variant-item">

																	<button className={`${selectRef.current[oneVarient.groupId] === oneSize.value ? `${avalClassRef.current} selected` : avaiableRef.current && avaiableRef.current.includes(oneSize.value) === true ? "available" : backOrderRef.current && backOrderRef.current.includes(oneSize.value) === true ?"backorder": "opacity_50"}`} type="button" value={oneSize.value} onClick={() => handleSelectRange(oneVarient.groupId, oneSize.value)} dangerouslySetInnerHTML={{ __html: oneSize && oneSize.displayName }}></button>

																</li>)
															})}
														</ul>
													</div>
												</div>
											</>)
										})}


										<div className="pdp-desc-restrictions">

											{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {
												return (<>
													{oneVarient && oneVarient.variantsMap && oneVarient.skuId === selectSkuResultRef.current ?
														oneVarient.specifications && oneVarient.specifications && oneVarient.specifications.shippingInformation ?

															containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.pdp_ship_account_restriction_info
																?
																<p onClick={() => scrollToView("specification")} className="pdp-scroll-to icon-content hyperLinkStyle">
																	<i className="bi bi-exclamation-circle-fill"></i>
																	<span className="icon-text" style={{ "font-size": ".875rem" }}>
																		{containerObject.atgResponse.response.response.familyVariyantProductDetails.pdp_ship_account_restriction_info}
																	</span>
																</p> : ""
															: "" : ""}
												</>)
											})}
										</div>


										<div className="pdp-desc-action">
											{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneVarient, index) => {
												return (<>
													{oneVarient && oneVarient.inventoryStatus != "replacement" && oneVarient.variantsMap && oneVarient.skuId === selectSkuResultRef.current ?
                                                        <>
                                                            {
															// oneVarient.priceInfo && oneVarient.priceInfo.complexPrice && oneVarient.priceInfo.complexPrice || oneVarient.priceInfo && oneVarient.priceInfo.regularPrice && oneVarient.priceInfo.regularPrice.length > 0 ?
                                                                 oneVarient.inventoryStatus == 'seasonal' ?
                                                                    <div className="row g-0 pdp-availability-msg">
                                                                        <div className="col">
                                                                            <p dangerouslySetInnerHTML={{__html : oneVarient.inventoryStatusMsg}}></p>

                                                                        </div>
                                                                    </div> :

                                                                    <div className="row g-0 pdp-desc-addToCart">

                                                                        <form onSubmit={handleAddToCart} method="post" name="addTocart" id="addToCart" className="col addToCart" >
                                                                            <div className="row g-0">
                                                                                <div className="col">
                                                                                    <div>
                                                                                        <label for="quantity" className="form-label">Quantity</label>
                                                                                    </div>
                                                                                    <div className="input-group c-input-group">
                                                                                        <button type="button" className="button-minus" data-field="quantity" aria-label="decreament the quantity" onClick={() => Decrement()}>
                                                                                            <i className="bi bi-dash"></i>
                                                                                        </button>


                                                                                        <input type="hidden" id="productId" name="productId" value={oneVarient.skuId} />

                                                                                        <label for={oneVarient.skuId} className="d-none" />
                                                                                        <input id={oneVarient.skuId} maxlength="3" max="999" name="quantity" type="text" value={count ? count : ""} className="quantities quantity-field form-control" onChange={handleChangeCount} />
                                                                                        <button type="button" className="button-plus" data-field="quantity" aria-label="increament the quantity" onClick={() => Increment()}>
                                                                                            <i className="bi bi-plus"></i>
                                                                                        </button>
                                                                                    </div >
                                                                                </div>
                                                                                <div className="col col-md-7 col-lg-8 cbTabProduct pdp-action">
                                                                                    { oneVarient.backOrderQty > 0 ?
                                                                                            <div className={`form-label pdp-status-msg c-red`}>Quantity Available: {oneVarient.backOrderQty}</div>
                                                                                        :
                                                                                        <>
                                                                                            <div className={`form-label pdp-status-msg ${oneVarient.inventoryStatus == "backorder" ? "c-red" : oneVarient.inventoryStatus == "available" ? "c-green" : "c-green ftm"} `}>({oneVarient.inventoryStatusMsg})</div>
                                                                                        </>
                                                                                    }
                                                                                    <input type="submit" name="submit" className={`btn ${oneVarient.backOrderQty > 0 &&  count > oneVarient.backOrderQty ? "btn-disable" : "btn-primary"} `} value={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isDLProduct == false ? "Add to Cart" : "Order Now"} />
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                // :
                                                                // <>
                                                                //     <div className="row g-0 pdp-availability-msg">
                                                                //         <div className="col">
                                                                //             <p>Currently no price available online.  Please contact customer service at 800.334.5551.</p>

                                                                //         </div>
                                                                //     </div>
                                                                // </>
                                                            }
                                                            {profileDetails && profileDetails.userTypeCheck && profileDetails.userTypeCheck.punchoutClient ? "" :
                                                                <div className="row g-0">
                                                                    <div className="col pdp-whislist">
                                                                        {profileDetails && profileDetails.transient == true ?
                                                                            <Link className="link-secondary modal-list" data-bs-target="#loginModal" data-bs-toggle="modal" data-bs-dismiss="modal" onClick={() => handleWishList(selectSkuResultRef.current, count, containerObject?.atgResponse?.response?.response?.familyVariyantDisplayName)}>
                                                                                add to wishlist
                                                                            </Link> : <Link className="link-secondary modal-list" data-bs-toggle="modal" data-bs-target="#newListModalww" data-bs-dismiss="modal" onClick={() => handleWishList(selectSkuResultRef.current, count, containerObject?.atgResponse?.response?.response?.familyVariyantDisplayName)}>
                                                                                add to wishlist
                                                                            </Link>}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
														:
                                                            oneVarient && oneVarient.inventoryStatus === "replacement" && oneVarient.variantsMap && oneVarient.skuId === selectSkuResultRef.current ?
                                                                <>
                                                                    <div class="col-12 col-md-12 order-3 mt-4 replacementTile restricted-item-row  pdp-desc">
                                                                        <div style={{"line-height": "1.35rem"}}>
                                                                            <span class="replacementNoticeTitle">This item is discontinued. Please view this replacement item: </span>
                                                                        </div>
                                                                        <div id="title">
                                                                            <h5 dangerouslySetInnerHTML={{ __html: oneVarient.replacementProduct && oneVarient.replacementProduct.displayName ? oneVarient.replacementProduct.displayName : "" }} />
                                                                            <span className="fwb ftms">Item #:</span>
                                                                            <span id="pdp-skuId">{oneVarient.replacementProduct && oneVarient.replacementProduct.productId ? oneVarient.replacementProduct.productId : ""}</span>
                                                                        </div>

                                                                        <div className="col-12 pdp-desc-price">
                                                                            {oneVarient.replacementProduct.priceInfo && oneVarient.replacementProduct.priceInfo.complexPrice && oneVarient.replacementProduct.priceInfo.complexPrice ?
                                                                                <>
                                                                                    <div className="prod-contract-disc d-flex align-items-start">
                                                                                        <div className="prod-contract-price">
                                                                                            {oneVarient.replacementProduct.priceInfo.retailLabel && oneVarient.replacementProduct.priceInfo.retailLabel != null ?
                                                                                                <span className="contract-price-heading">{oneVarient.replacementProduct.priceInfo.baseLabel}</span>
                                                                                                :""
                                                                                            }

                                                                                            <span id={`ecommPrice_${oneVarient?.replacementProduct?.productId}`} className="contract-price-value">{oneVarient.replacementProduct.priceInfo.complexPrice[0].qtyRangePrice[1]}</span>
                                                                                        </div>

                                                                                        {oneVarient.replacementProduct.priceInfo.retailLabel && oneVarient.replacementProduct.priceInfo.retailLabel != null ?
                                                                                            <div className="prod-retail-price">
                                                                                                <span className="retail-price-heading">{oneVarient.replacementProduct.priceInfo.retailLabel}</span>
                                                                                                {oneVarient.replacementProduct.priceInfo.retailPrice != "$0.00" ?
                                                                                                    <span className=" pdp list-price-value">{oneVarient.replacementProduct.priceInfo.complexPrice[0].qtyRangePrice[2]}</span> : ""}
                                                                                            </div>
                                                                                            :
                                                                                            ""
                                                                                        }
                                                                                    </div>
                                                                                    <span className="fdp-item-price-label">Qty Discount Available</span>
                                                                                </>
                                                                                :
                                                                                oneVarient.replacementProduct.priceInfo && oneVarient.replacementProduct.priceInfo.regularPrice && oneVarient.replacementProduct.priceInfo.regularPrice.length > 0 ?
                                                                                    <>
                                                                                        {oneVarient.replacementProduct.priceInfo.retailLabel && oneVarient.replacementProduct.priceInfo.retailLabel != null ?
                                                                                            <div className="prod-contract-disc d-flex align-items-start">
                                                                                                <div className="prod-contract-price">
                                                                                                    <span className="contract-price-heading">{oneVarient.replacementProduct.priceInfo.baseLabel}</span>
                                                                                                    <span id={`ecommPrice_${selectSkuResultRef.current}`} className="contract-price-value">{oneVarient.replacementProduct.priceInfo.regularPrice[0]}</span>
                                                                                                </div>
                                                                                                <div className="prod-retail-price">
                                                                                                    <span className="retail-price-heading">{oneVarient.replacementProduct.priceInfo.retailLabel}</span>
                                                                                                    <span className=" pdp list-price-value">{oneVarient.replacementProduct.priceInfo.regularPrice[1]}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            :
                                                                                            oneVarient.replacementProduct.priceInfo.regularPrice.length == 1 ?
                                                                                                <div id={`ecommPrice_${selectSkuResultRef.current}`} className="pdp-order-price">{oneVarient.replacementProduct.priceInfo.regularPrice}</div>
                                                                                                :
                                                                                                <div className="prod-contract-disc d-flex align-items-center">
                                                                                                    <div className="prod-contract-price">
                                                                                                        <span className="sale-price-value c-red">
                                                                                                            {oneVarient.replacementProduct.priceInfo.regularPrice[0]}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div className="prod-retail-price">
                                                                                                        <span className=" pdp list-price-value">
                                                                                                            {oneVarient.replacementProduct.priceInfo.regularPrice[1]}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>
                                                                                        }
                                                                                    </>
                                                                                :
                                                                                ""
                                                                            }
                                                                        </div>

                                                                        <div class="col-12 replacementBtn cbProduct pdp-action">
                                                                            {oneVarient.replacementProduct
                                                                                && oneVarient.replacementProduct.inventoryStatusMsg ?
                                                                                    <div className={`form-label ${oneVarient.replacementProduct.inventoryStatus == "backorder" ? "c-red" : oneVarient.replacementProduct.inventoryStatus == "available" ? "c-green" : "c-green ftm"} `}>({oneVarient.replacementProduct.inventoryStatusMsg})</div>
                                                                                    : ""
                                                                            }
                                                                            <Link to={oneVarient.replacementProduct.url  ? oneVarient.replacementProduct.url  : ""} class="btn btn-primary">See Replacement</Link>
                                                                        </div>
                                                                        {profileDetails && profileDetails.userTypeCheck && profileDetails.userTypeCheck.punchoutClient ? "" :
                                                                            <div className="row g-0">
                                                                                <div className="col pdp-whislist">
                                                                                    {profileDetails && profileDetails.transient == true ?
                                                                                        <Link className="link-secondary modal-list" data-bs-target="#loginModal" data-bs-toggle="modal" data-bs-dismiss="modal" onClick={() => handleWishList(selectSkuResultRef.current, count, containerObject?.atgResponse?.response?.response?.familyVariyantDisplayName)}>
                                                                                            add to wishlist
                                                                                        </Link> : <Link className="link-secondary modal-list" data-bs-toggle="modal" data-bs-target="#newListModalww" data-bs-dismiss="modal" onClick={() => handleWishList(oneVarient.replacementProduct.productId, count, oneVarient.replacementProduct.displayName)}>
                                                                                            add to wishlist
                                                                                        </Link>}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </>
                                                                : ""
														}
												</>)
											})}
										</div>
									</div>
								</div>
							</div>

						</div>

					</> : ""}



				{/* CBS family tabs ended here */}


				{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource ? "" :
					<><div className=" row accordion accordion-flush pdp-detail-info pdp-section-pd" id="pdp-detail-accordion">
						{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.longDescription ?

							<section className=" col-12 accordion-item pdp-detail-desc" id="description">
								<h2 className="d-block d-md-none accordion-header" id="pdp-desc-heading">
									<button id="description_accordion_button" className=" pdp accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#pdp-desc-body" aria-expanded="false" aria-controls="pdp-desc-body">
										Description
									</button>
								</h2>
								<div id="pdp-desc-body" className="accordionIsTablet accordion-collapse collapse" aria-labelledby="pdp-desc-heading" data-bs-parent="#pdp-detail-accordion">
									<div className="accordion-body">
										<h2 className="d-none d-md-block">Description</h2>
										<div className="row pdp-desc-content">

											{relatedResourcesObjRef.current ?
												<><div className="col-md-9 pdp-desc-detail">

													{isDlproductRef.current == false ? "" :
														containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.shortDescription ? <div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.shortDescription }} /> : ""
													}

													{ProductTabsDescriptionRef.current ? <div dangerouslySetInnerHTML={{ __html: ProductTabsDescriptionRef.current }} /> : containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.longDescription ? <div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.longDescription }} /> : ""}
												</div>
													<div className="col-md-3">
														<ul className="pdp-desc-resource ftl list-unstyled">
															{relatedResourcesObjRef.current && relatedResourcesObjRef.current.resourceItemsList && relatedResourcesObjRef.current.resourceItemsList.map((oneResourceItems) => {
																return (<>
																	<li>
																		{oneResourceItems && oneResourceItems.prop65MsgLinkText ?
																			<Link id="pdprelatedResources" className="fwb icon-content" onClick={() => handleWarning(oneResourceItems && oneResourceItems.prop65ModalHeader,  ProductTabspropsMessageRef?.current ?ProductTabspropsMessageRef?.current : oneResourceItems && oneResourceItems.description, oneResourceItems && oneResourceItems.icon)} >

																				{iconObjectMap[oneResourceItems && oneResourceItems.categoryIconMap[oneResourceItems.keyValue]]}

																				<span className="icon-text" dangerouslySetInnerHTML={{ __html: oneResourceItems && oneResourceItems.prop65MsgLinkText }}></span>
																			</Link> :
																			oneResourceItems && oneResourceItems.pdfPath ?
																				<a target="_blank" href={oneResourceItems && oneResourceItems.pdfPath ? oneResourceItems.pdfPath : ""} title="" className="fwb icon-content">

																					{iconObjectMap[oneResourceItems && oneResourceItems.categoryIconMap[oneResourceItems.keyValue]]}

																					<span className="icon-text" dangerouslySetInnerHTML={{ __html: oneResourceItems && oneResourceItems.displayName }}></span>
																				</a> :


																				<a href={oneResourceItems && oneResourceItems.cUrl ? oneResourceItems.cUrl : ""} title="" className="fwb icon-content">

																					{iconObjectMap[oneResourceItems && oneResourceItems.categoryIconMap[oneResourceItems.keyValue]]}

																					<span className="icon-text" dangerouslySetInnerHTML={{ __html: oneResourceItems && oneResourceItems.displayName }}></span>
																				</a>}
																	</li>
																</>)
															})}

															{/* {releatedOrderRef.current && releatedOrderRef.current.map((oneOrder) => {
																return (<> */}
															{relatedResourcesObjRef.current && relatedResourcesObjRef.current.contentItemList && relatedResourcesObjRef.current.contentItemList.map((oneContentItem) => {
																return (<>
																	{/* {oneOrder == oneContentItem.contentMediaType ? */}
																	<li>
																		{oneContentItem && oneContentItem.pdfPath ?
																			<a target="_blank" href={oneContentItem && oneContentItem.pdfPath ? oneContentItem.pdfPath : ""} title="" className="fwb icon-content">

																				{iconObjectMap[oneContentItem && oneContentItem.categoryIconMap[oneContentItem.keyValue]]}

																				<span className="icon-text" dangerouslySetInnerHTML={{ __html: oneContentItem && oneContentItem.displayName }}></span>
																			</a> :


																			<a href={oneContentItem && oneContentItem.cUrl ? oneContentItem.cUrl : ""} title="" className="fwb icon-content">

																				{iconObjectMap[oneContentItem && oneContentItem.categoryIconMap[oneContentItem.keyValue]]}

																				<span className="icon-text" dangerouslySetInnerHTML={{ __html: oneContentItem && oneContentItem.displayName }}></span>
																			</a>}
																	</li>
																	{/* : ""} */}
																</>)
															})}
															{/* </>)
															})} */}


														</ul>
													</div>

												</> :

												<div className="col pdp-desc-detail">
													{isDlproductRef.current == false ? "" :
														containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.shortDescription ? <div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.shortDescription }} /> : ""}
													{ProductTabsDescriptionRef.current ? <div dangerouslySetInnerHTML={{ __html: ProductTabsDescriptionRef.current }} /> : containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.longDescription ? <div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.longDescription }} /> : ""}
												</div>
											}
										</div>
									</div>
								</div>
							</section>
							: ""}

						{/* specification */}


						{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdp_heading_label_specifications || containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.pdp_heading_label_specifications && containerObject.atgResponse.response.response.familyVariyantProductDetails.pdp_heading_label_specifications || containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyItem && containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductsList ?
							<section className=" col-12 accordion-item pdp-detail-spec" id="specification">
								<h2 className="d-block d-md-none accordion-header" id="pdp-spec-heading">
									<button id="specification_accordion_button" className=" pdp accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#pdp-spec-body" aria-expanded="false" aria-controls="pdp-spec-body">
										Specifications
									</button>
								</h2>
								<div id="pdp-spec-body" className="accordionIsTablet accordion-collapse collapse" aria-labelledby="pdp-spec-heading" data-bs-parent="#pdp-detail-accordion">
									<div className="accordion-body">
										<h2 className="d-none d-md-block">Specifications</h2>
										<div className="pdp-spec-content">
											<div>

												<dl>
													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.hazmatWarning ?
														<>
															<dt>
																{containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_restriction_info}
															</dt>
															<dd>
																<ul>
																	<li className="icon-content pdm">
																		<i className="bi bi-exclamation-circle-fill"></i>
																		<span className="icon-text" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.hazmatWarning }}></span>
																	</li>
																</ul>
															</dd>
														</> : ""}
													{/* what include and not include for CBS Product start here */}
													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem ?
														<>
															<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_whats_included }}>

															</dt>
															<dd>
																<ul onMouseLeave={()=>handleRemoveQuickView()}>
																	{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem && 
																	containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem.map((oneIncludeItem, index) => {
																		return (<>

																			{ showMoreRef.current && showMoreRef.current["includedItem"] > index ?
																				oneIncludeItem && oneIncludeItem.includedLinkUrl ?
																				// <li><a href={ oneIncludeItem.includedLinkUrl}  dangerouslySetInnerHTML={{ __html:oneIncludeItem?.includedDisplayName}}/></li>
																				<li className="include-view-desc" style={{position:"relative"}} onMouseLeave={()=>handleRemoveQuickView()}>
																					{isProduct(oneIncludeItem.includedLinkUrl) ?
																					<>
																						<div class="c-include-link ">
																							<a className="hyperLinkStyle quick-hover-link pdp-include-view" href={oneIncludeItem?.includedLinkUrl} onMouseEnter={()=>handleWhatsIncludeHover(oneIncludeItem.includedLinkUrl,index,"include")} dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName }} />
																						</div>
																						{!oneIncludeItem.familyProduct && oneIncludeItem.addtoCart?
																						<div class="text-end include-add-cart" onClick={(event)=>handleAddToCart(event, getLastPathname(oneIncludeItem.includedLinkUrl))}>
																							<img src="/vaststatic/deployed-assets/CbSite/cart1-icon.png" alt="" class="cart-icon"/>
																							<span className="add-to-cart-accord">Add to cart</span>
																						</div> :<></>
																						}
																					</>
																					:
																					<div class="c-include-link">
																						<a className="hyperLinkStyle pdp-include-view" href={oneIncludeItem?.includedLinkUrl} dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName }} />
																					</div>}
																					{console.log('boolean condition...',includeQuickRefId?.current == getLastPathname(oneIncludeItem.includedLinkUrl).concat("_").concat(index))}
																					{/* { includeQuickRefId?.current == getLastPathname(oneIncludeItem.includedLinkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart} isRetailPrice={isRetailPrice} isFamilyProduct={oneIncludeItem.familyProduct} productId={ hoverProductIdRef.current}/>: ""} */}
																					{ includeQuickRefId?.current == getLastPathname(oneIncludeItem.includedLinkUrl).concat("_").concat(index) && includeQuickRef?.current ? <ProductQuickViewModal productObj={includeQuickRef?.current} solrValue={solrValueRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack} isHover={true} addToCartSuccessFromWhatsInclude={addToCartSuccessFromWhatsInclude}/>: ""}

																				</li> 
																				:
																					// <li style={{position:"relative"}}><a className="hyperLinkStyle " onMouseEnter={()=>handleIncludeQuickView(oneIncludeItem.includedLinkUrl,index)} onClick={()=>handleIncludeQuickView(oneIncludeItem.includedLinkUrl,index)} dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName }} />{ includeQuickRefId?.current == getLastPathname(oneIncludeItem.includedLinkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart}/>: ""}</li> : ""
																					<li dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName }}></li>
																				: ""}
																		</>)
																	})}
																	<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${includedItemLengthRef.current && includedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("includedItem")}>expand to see full list</Link>
																</ul>
															</dd>
														</> : ""}

													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem ?
														<>
															<dt >
																Needed But Not Included:
															</dt>
															<dd>
																<ul  onMouseLeave={()=>handleRemoveQuickView()}>
																	{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem && 
																	containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem.map((oneNotIncludeItem, index) => {

																		return (<>

																			{showMoreRef.current && showMoreRef.current["notIncludedItem"] > index ?
																				oneNotIncludeItem && oneNotIncludeItem.excludedLinkUrl ?
							
																			<li className="include-view-desc" style={{position:"relative"}} onMouseLeave={()=>handleRemoveQuickView()}>
																				{isProduct(oneNotIncludeItem.excludedLinkUrl) ?
																				<>
																					<div class="c-include-link">
																						<a href={oneNotIncludeItem?.excludedLinkUrl} className="hyperLinkStyle quick-hover-link pdp-include-view" onMouseEnter={()=>handleWhatsIncludeHover(oneNotIncludeItem.excludedLinkUrl,index, "notInclude")}  dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }} />
																					</div>
																					{!oneNotIncludeItem.familyProduct && oneNotIncludeItem.addtoCart?
																					<div class="text-end include-add-cart" onClick={(event)=>handleAddToCart(event, getLastPathname(oneNotIncludeItem.excludedLinkUrl))}>
																						<img src="/vaststatic/deployed-assets/CbSite/cart1-icon.png" alt="" class="cart-icon"/>
																						<span className="add-to-cart-accord">Add to cart</span>
																					</div>:<></>}
																				</>
																				:
																				<div class="c-include-link">
																					<a href={oneNotIncludeItem?.excludedLinkUrl} className="hyperLinkStyle pdp-include-view"  dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }} />
																				</div>}

																				
																				{/* { includeQuickRefId?.current == getLastPathname(oneNotIncludeItem?.excludedLinkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart} isRetailPrice={isRetailPrice} isFamilyProduct={oneNotIncludeItem.familyProduct} productId={hoverProductIdRef.current}/>: ""} */}
																				{ includeQuickRefId?.current == getLastPathname(oneNotIncludeItem?.excludedLinkUrl).concat("_").concat(index) && includeQuickRef?.current  ? <ProductQuickViewModal productObj={includeQuickRef?.current} solrValue={solrValueRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack} isHover={true} addToCartSuccessFromWhatsInclude={addToCartSuccessFromWhatsInclude}/>: ""}
																			</li> 
																		
																				//		<li><a href={oneNotIncludeItem?.excludedLinkUrl}  dangerouslySetInnerHTML={{ __html: oneNotIncludeItem.notIncludedDisplayName}} onClick={()=>handleIncludeQuickView(oneNotIncludeItem.excludedLinkUrl,index)} onMouseEnter={()=>handleIncludeQuickView(oneNotIncludeItem.excludedLinkUrl,index)}/></li>:
																					// <li style={{position:"relative"}}><a className="hyperLinkStyle " onMouseEnter={()=>{handleIncludeQuickView(oneNotIncludeItem.excludedLinkUrl,index)}} onClick={()=>handleIncludeQuickView(oneNotIncludeItem.excludedLinkUrl,index)} dangerouslySetInnerHTML={{ __html: oneNotIncludeItem.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }} />{ includeQuickRefId?.current == getLastPathname(oneNotIncludeItem.excludedLinkUrl).concat("_").concat(index) ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart}/>: ""}</li>
																					 :
																					<li dangerouslySetInnerHTML={{ __html: oneNotIncludeItem.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }}></li>
																				: ""}
																		</>)
																	})}
																	<a style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${notIncludedItemLengthRef.current && notIncludedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("notIncludedItem")}>expand to see full list</a>
																</ul>
															</dd>
														</> : ""}


													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.length > 0 ?
														<>
															<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_specs }}>

															</dt>
															<dd>
																<ul>
																	{containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.map((oneSpecification, index) => {
																		return (<>

																			{showMoreRef.current && showMoreRef.current["featuredItem"] > index ?

																				<li dangerouslySetInnerHTML={{ __html: oneSpecification && oneSpecification.specificationDisplayName.concat(": ").concat(oneSpecification.stringValue) }}></li>
																				: ""}
																		</>)
																	})}
																	<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${featuresLengthRef.current && featuresLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("featuredItem")}>expand to see full list</Link>
																</ul>
															</dd>
														</> : ""}
													{/* what include and not include for CBS Product end  here */}
													{/* return policy for CBS Product start  here */}
													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_return_policy ?
														<>
															<dt>
																{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_return_policy}
															</dt>
															<dd>
																<p className="pdp-return-policy pdm" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_return_policy ? containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_return_policy : containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_no_return_policy ? containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_no_return_policy : containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp__dl_return_policy ? containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp__dl_return_policy : containerObject.atgResponse.response?.response?.standardResult?.tabsResult?.pdpspecifications?.pdp_living_return_policy ? containerObject.atgResponse.response?.response?.standardResult?.tabsResult?.pdpspecifications?.pdp_living_return_policy : "" }}></p>
															</dd>
														</>
														: ""}
													{/* return policy for CBS Product end here */}

													{/* what include and not include for family tabs Product start here */}
													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean ?
														<>

															{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.skus?.map((oneSku, index) => {
																return (<>
																	{oneSku && oneSku.skuId === selectSkuResultRef.current ? <>



																		{oneSku.specifications.shippingInformation && oneSku.specifications.shippingInformation.length > 0 ? <>
																			<dt>{containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean?.staticLabels?.shippingInfo}</dt>
																			<dd>
																				<ul>
																					<li className="icon-content pdm">
																						<i className="bi bi-exclamation-circle-fill"></i>
																						<span className="icon-text" dangerouslySetInnerHTML={{ __html: oneSku.specifications.shippingInformation && oneSku.specifications.shippingInformation }}></span>
																					</li>
																				</ul>
																			</dd>
																		</> : ""}

																		{oneSku.specifications.whatsIncludedList && oneSku.specifications.whatsIncludedList.length > 0 ?
																			<>
																				<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.staticLabels?.includedList }}>

																				</dt>
																				<dd>
																					<ul onMouseLeave={()=>handleRemoveQuickView()}>
																						{oneSku.specifications.whatsIncludedList.map((oneIncludeItem, index) => {
																							return (<>

																								{showMoreRef.current && showMoreRef.current["includedItem"] > index ?
																									oneIncludeItem.linkUrl ?
																								//	<li style={{position:"relative"}}><a href={oneIncludeItem?.linkUrl} className="hyperLinkStyle " onClick={()=>handleIncludeQuickView(oneIncludeItem?.linkUrl,index)} onMouseEnter={()=>handleIncludeQuickView(oneIncludeItem?.linkUrl,index)} dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.description) : oneIncludeItem.description }} />{ includeQuickRefId?.current == getLastPathname(oneIncludeItem?.linkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart}/>: ""}</li> 
																									<li className="include-view-desc" style={{position:"relative"}} onMouseLeave={()=>handleRemoveQuickView()}>
																									{isProduct(oneIncludeItem.linkUrl)?
																									<>
																										<div class="c-include-link">
																											<a href={oneIncludeItem?.linkUrl} className="hyperLinkStyle quick-hover-link pdp-include-view" onMouseEnter={()=>handleWhatsIncludeHover(oneIncludeItem?.linkUrl,index, "include")} dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.description) : oneIncludeItem.description }} />
																										</div>
																										{!oneIncludeItem.familyProduct && oneIncludeItem.addtoCart?
																										<div class="text-end include-add-cart" onClick={(event)=>handleAddToCart(event, getLastPathname(oneIncludeItem.linkUrl))}>
																											<img src="/vaststatic/deployed-assets/CbSite/cart1-icon.png" alt="" class="cart-icon"/>
																											<span className="add-to-cart-accord">Add to cart</span>
																										</div>:<></>}
																									</>
																									:
																									<div class="c-include-link">
																										<a href={oneIncludeItem?.linkUrl} className="hyperLinkStyle pdp-include-view" onClick={()=>handleWhatsIncludeHover(oneIncludeItem?.linkUrl,index)} dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.description) : oneIncludeItem.description }} />
																									</div>
																									}
																									
																									{/* { includeQuickRefId?.current == getLastPathname(oneIncludeItem?.linkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart} isRetailPrice={isRetailPrice} isFamilyProduct={oneIncludeItem.familyProduct} productId={hoverProductIdRef.current}/>: ""} */}
																									{ includeQuickRefId?.current == getLastPathname(oneIncludeItem?.linkUrl).concat("_").concat(index) && includeQuickRef?.current  ?  <ProductQuickViewModal productObj={includeQuickRef?.current} solrValue={solrValueRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack} isHover={true} addToCartSuccessFromWhatsInclude={addToCartSuccessFromWhatsInclude}/>: ""}

																								</li> 
																								//	<li><a href={oneIncludeItem?.linkUrl}  dangerouslySetInnerHTML={{ __html: oneIncludeItem?.description}} onMouseEnter={()=>handleIncludeQuickView(oneIncludeItem.linkUrl,index)}/></li>
																									:
																										// <li style={{position:"relative"}} > <a className="hyperLinkStyle " onMouseEnter={()=>handleIncludeQuickView(oneIncludeItem.linkUrl,index)} onClick={()=>handleIncludeQuickView(oneIncludeItem.linkUrl,index)} dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.description }} />{ includeQuickRefId?.current == getLastPathname(oneIncludeItem.linkUrl).concat("_").concat(index) ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart}/>: ""}</li> :
																										<li dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.description }}></li>
																									: ""}
																							</>)
																						})}
																						<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${includedItemLengthRef.current && includedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyProductIncludedItem")}>expand to see full list</Link>
																					</ul>
																				</dd>
																			</> : ""}

																		{oneSku.specifications.whatsExcludedList && oneSku.specifications.whatsExcludedList.length > 0 ?
																			<>
																				<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response?.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.staticLabels?.excludedList }}>

																				</dt>
																				<dd>
																					<ul onMouseLeave={()=>handleRemoveQuickView()}>
																						{oneSku.specifications.whatsExcludedList.map((oneNotIncludeItem, index) => {
																							return (<>

																								{showMoreRef.current && showMoreRef.current["notIncludedItem"] > index ?
																									oneNotIncludeItem.linkUrl ?
																								//	<li><a href={oneNotIncludeItem.linkUrl} onMouseEnter={()=>handleIncludeQuickView(oneNotIncludeItem.linkUrl,index)} dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.description}}/></li>
																								<li className="include-view-desc" style={{position:"relative"}} onMouseLeave={()=>handleRemoveQuickView()}>
																									{isProduct(oneNotIncludeItem.linkUrl)?
																									<>
																										<div class="c-include-link">
																										<a href={oneNotIncludeItem.linkUrl} className="hyperLinkStyle pdp-include-view quick-hover-link" onMouseEnter={()=>handleWhatsIncludeHover(oneNotIncludeItem.linkUrl,index, "notInclude")} dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.description}}/>
																										</div>
																										{!oneNotIncludeItem.familyProduct && oneNotIncludeItem.addtoCart?
																										<div class="text-end include-add-cart" onClick={(event)=>handleAddToCart(event, getLastPathname(oneNotIncludeItem.linkUrl))}>
																											<img src="/vaststatic/deployed-assets/CbSite/cart1-icon.png" alt="" class="cart-icon"/>
																											<span className="add-to-cart-accord">Add to cart</span>
																										</div>:<></>}
																									</>
																									:
																									<div class="c-include-link">
																										<a href={oneNotIncludeItem?.linkUrl} className="hyperLinkStyle pdp-include-view"  dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.includedQty ? oneNotIncludeItem.includedQty.concat(" ").concat(oneNotIncludeItem.description) : oneNotIncludeItem.description }} />
																									</div>
																									}
																									{/* { includeQuickRefId?.current == getLastPathname(oneNotIncludeItem?.linkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart} isRetailPrice={isRetailPrice} isFamilyProduct={oneNotIncludeItem.familyProduct} productId={hoverProductIdRef.current}/>: ""} */}
																									{ includeQuickRefId?.current == getLastPathname(oneNotIncludeItem?.linkUrl).concat("_").concat(index) && includeQuickRef?.current  ?  <ProductQuickViewModal productObj={includeQuickRef?.current} solrValue={solrValueRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack} isHover={true} addToCartSuccessFromWhatsInclude={addToCartSuccessFromWhatsInclude}/>: ""}

																								</li>
																								:
																										// <li style={{position:"relative"}}> <a className="hyperLinkStyle " onMouseEnter={()=>handleIncludeQuickView(oneNotIncludeItem.linkUrl,index)}   onClick={()=>handleIncludeQuickView(oneNotIncludeItem.linkUrl,index)} dangerouslySetInnerHTML={{ __html: oneNotIncludeItem && oneNotIncludeItem.description }} />{ includeQuickRefId?.current == getLastPathname(oneNotIncludeItem.linkUrl).concat("_").concat(index) ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart}/>: ""}</li> :
																										<li dangerouslySetInnerHTML={{ __html: oneNotIncludeItem && oneNotIncludeItem.description }}></li>
																									: ""}
																							</>)
																						})}
																						<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${notIncludedItemLengthRef.current && notIncludedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyProductNotIncludedItem")}>expand to see full list</Link>
																					</ul>
																				</dd>
																			</> : ""}

																		{oneSku.specifications.specs && oneSku.specifications.specs.length > 0 ?
																			<>
																				<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.familyVariyantProductDetails?.productVariantsResult?.masterProductBean?.staticLabels?.specFeatures }}>
																				</dt>
																				<dd>
																					<ul>
																						{oneSku.specifications.specs.map((oneSpecs, index) => {
																							return (<>

																								{showMoreRef.current && showMoreRef.current["featuredItem"] > index ?

																									<li dangerouslySetInnerHTML={{ __html: oneSpecs && oneSpecs }}></li>
																									: ""}
																							</>)
																						})}
																						<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${featuresLengthRef.current && featuresLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyProductFeaturedItem")}>expand to see full list</Link>
																					</ul>
																				</dd>
																			</> : ""}

																		{oneSku.specifications.returnPolicy ? <>
																			<dt>{containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult?.masterProductBean?.staticLabels?.returnPolicy}</dt>
																			<dd>
																				<p className="pdp-return-policy pdm" dangerouslySetInnerHTML={{ __html: oneSku.specifications.returnPolicy && oneSku.specifications.returnPolicy }}></p>

																			</dd>
																		</> : ""}


																	</> : ""}
																</>)
															})}
														</> : ""}

													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.familyItem && containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductsList ?
														<div className="spec-prod-select">
															<form >
																<div className="row align-items-center">
																	<div className="col-auto">
																		<label for="fdp-spec-selection" className="form-label">Choose an Item:</label>
																	</div>
																	<div className="col-12 col-md-7">
																		<select id="fdp-spec-selection" className="form-select" onChange={specification} >
																			<option selected="selected" disabled="disabled">&nbsp;</option>
																			{containerObject.atgResponse.response.response.familyProduct.familyItem.familyProductsList.map((oneProductList) => {
																				return (
																					<option value={oneProductList.id} dangerouslySetInnerHTML={{ __html: "#".concat(oneProductList.id).concat(" - ").concat(oneProductList.displayName) }}></option>)
																			})}
																		</select>
																	</div>
																</div>
															</form>

															{productSpecficationDetailsRef.current ? <>


																{productSpecficationDetailsRef.current.familyProduct.hazmatWarning ? <>
																	<dt>{productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_restriction_info}</dt>
																	<dd>

																		<ul>
																			<li className="icon-content pdm">
																				<i className="bi bi-exclamation-circle-fill"></i>
																				<span className="icon-text" dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct.hazmatWarning }}>

																				</span>
																			</li>
																		</ul>


																	</dd>
																</> : ""}

																{productSpecficationDetailsRef.current?.familyProduct?.includedItem && productSpecficationDetailsRef.current.familyProduct.includedItem.length > 0 ?
																	<>
																		<dt dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_whats_included }}>

																		</dt>
																		<dd>
																			<ul>
																				{productSpecficationDetailsRef.current.familyProduct.includedItem.map((oneIncludeItem, index) => {
																					return (<>
																							{showMoreRef.current && showMoreRef.current["includedItem"] > index ?
                                                                                            oneIncludeItem && oneIncludeItem.includedLinkUrl ?
                                                                                                //<li dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedQty ? oneIncludeItem?.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName}}>
                                                                                                <li>
                                                                                                {isProduct(oneIncludeItem.includedLinkUrl)?
                                                                                                <>
                                                                                                <div className="d-flex">
                                                                                                <div class="c-include-link">
                                                                                                    <a href={oneIncludeItem?.includedLinkUrl} className="hyperLinkStyle quick-hover-link pdp-include-view" onMouseEnter={()=>handleWhatsIncludeHover(oneIncludeItem?.includedLinkUrl,index, "include")}  dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedQty ? oneIncludeItem?.includedLinkUrl.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName }} />
                                                                                                    </div>  
                                                                                                    {!oneIncludeItem.familyProduct && oneIncludeItem.addtoCart?
                                                                                                    <div class="text-end include-add-cart" onClick={(event)=>handleAddToCart(event, getLastPathname(oneIncludeItem.includedLinkUrl))}>
                                                                                                        <img src="/vaststatic/deployed-assets/CbSite/cart1-icon.png" alt="" class="cart-icon"/><span className="add-to-cart-accord">Add to cart</span>
                                                                                                        </div>:
                                                                                                        <></>}
                                                                                                        </div>
                                                                                                </>
                                                                                                
                                                                                                 : <>
                                                                                                <div class="c-include-link">
                                                                                                    <a href={oneIncludeItem?.includedLinkUrl} className="hyperLinkStyle pdp-include-view"  dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedQty ? oneIncludeItem?.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName}} />
                                                                                                </div>
                                                                                                </>
                                                                                            }
                                                                                            {includeQuickRefId?.current == getLastPathname(oneIncludeItem.includedLinkUrl).concat("_").concat(index)  ? <ProductQuickViewModal productObj={includeQuickRef?.current} solrValue={solrValueRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack} isHover={true} addToCartSuccessFromWhatsInclude={addToCartSuccessFromWhatsInclude}/>: ""}
                                                                                                </li>
                                                                                                : <li>
                                                                                            <div className="c-include-link">
                                                                                            {oneIncludeItem?.includedLinkUrl ? (
                                                                                            <a href={oneIncludeItem?.includedLinkUrl} className="hyperLinkStyle pdp-include-view" onMouseEnter={() => handleWhatsIncludeHover( oneIncludeItem?.includedLinkUrl, index, "include") } dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedDisplayName, }} ></a>
                                                                                            ) : (<span dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedDisplayName, }} ></span>)}
                                                                                            </div>
                                                                                                </li>
                                                                                            : ""}
		
																					</>)
																				})}
																				<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${includedItemLengthRef.current && includedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyVarientincludedItem")}>expand to see full list</Link>
																			</ul>
																		</dd>
																	</> : ""}

																{productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.notIncludedItem && productSpecficationDetailsRef.current.familyProduct.notIncludedItem.length > 0 ?
																	<>
																		<dt>
																			Needed But Not Included:
																		</dt>
																		<dd>
																			<ul onMouseLeave={()=>handleRemoveQuickView()}>
																				{productSpecficationDetailsRef.current.familyProduct.notIncludedItem.map((oneNotIncludeItem, index) => {
																					return (<>

																						{showMoreRef.current && showMoreRef.current["notIncludedItem"] > index ?
																							oneNotIncludeItem && oneNotIncludeItem.excludedLinkUrl ?
																						//	<li style={{position:"relative"}}><a href={oneNotIncludeItem?.excludedLinkUrl} className="hyperLinkStyle " onMouseEnter={()=>handleIncludeQuickView(oneNotIncludeItem.excludedLinkUrl,index)}   dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }} />{ includeQuickRefId?.current == getLastPathname(oneNotIncludeItem?.excludedLinkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart}/>: ""}</li> 
																							<li className="include-view-desc" style={{position:"relative"}} onMouseLeave={()=>handleRemoveQuickView()}>
																								{isProduct(oneNotIncludeItem.excludedLinkUrl) ? 
																								<>
																									<div class="c-include-link">
																										<a href={oneNotIncludeItem?.excludedLinkUrl} className="hyperLinkStyle quick-hover-link pdp-include-view" onMouseEnter={()=>handleWhatsIncludeHover(oneNotIncludeItem.excludedLinkUrl,index, "notInclude")}  dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }} />
																									</div>
																									{!oneNotIncludeItem.familyProduct && oneNotIncludeItem.addtoCart?
																									<div class="text-end include-add-cart" onClick={(event)=>handleAddToCart(event, getLastPathname(oneNotIncludeItem.excludedLinkUrl))}>
																										<img src="/vaststatic/deployed-assets/CbSite/cart1-icon.png" alt="" class="cart-icon"/>
																										<span className="add-to-cart-accord">Add to cart</span>
																									</div>:<></>}
																								</>
																								:<>
																									<div class="c-include-link">
																										<a href={oneNotIncludeItem?.excludedLinkUrl} className="hyperLinkStyle pdp-include-view"  dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }} />
																									</div>																								</>}
																								
																								{/* { includeQuickRefId?.current == getLastPathname(oneNotIncludeItem?.excludedLinkUrl).concat("_").concat(index)  ? <IncludedQuickView productData={includeQuickRef?.current} addToCart={handleAddToCart} isRetailPrice={isRetailPrice} isFamilyProduct={oneNotIncludeItem.familyProduct} productId={hoverProductIdRef.current}/>: ""} */}
																								{ includeQuickRefId?.current == getLastPathname(oneNotIncludeItem?.linkUrl).concat("_").concat(index) && includeQuickRef?.current ?  <ProductQuickViewModal productObj={includeQuickRef?.current} solrValue={solrValueRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack} isHover={true} addToCartSuccessFromWhatsInclude={addToCartSuccessFromWhatsInclude}/>: ""}

																								</li> 																							
																							:
																							<li dangerouslySetInnerHTML={{ __html: oneNotIncludeItem && oneNotIncludeItem.notIncludedDisplayName }}></li>
																							: ""}
																					</>)
																				})}
																				<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${notIncludedItemLengthRef.current && notIncludedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyVarientnotIncludedItem")}>expand to see full list</Link>
																			</ul>
																		</dd>
																	</> : ""}

																{productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.specificationList && productSpecficationDetailsRef.current.familyProduct.specificationList.length > 0 ?
																	<>
																		<dt dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_specs }}>
																		</dt>
																		<dd>
																			<ul>
																				{productSpecficationDetailsRef.current.familyProduct.specificationList.map((oneSpecs, index) => {
																					return (<>

																						{showMoreRef.current && showMoreRef.current["featuredItem"] > index ?

																							<li dangerouslySetInnerHTML={{ __html: oneSpecs && oneSpecs.specificationDisplayName.concat(": ").concat(oneSpecs.stringValue) }}></li>
																							: ""}
																					</>)
																				})}
																				<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed pdp-include-view ${featuresLengthRef.current && featuresLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyVarientfeaturedItem")}>expand to see full list</Link>
																			</ul>
																		</dd>
																	</> : ""}




																{productSpecficationDetailsRef.current.familyProduct?.pdp_return_policy || productSpecficationDetailsRef.current.familyProduct?.pdp_no_return_policy ? <>
																	<dt>{productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_return_policy}</dt>
																	<dd>
																		<p className="pdp-return-policy pdm" dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct?.pdp_return_policy ? productSpecficationDetailsRef.current.familyProduct.pdp_return_policy : productSpecficationDetailsRef.current.familyProduct?.pdp_no_return_policy ? productSpecficationDetailsRef.current.familyProduct.pdp_no_return_policy : "" }}></p>

																	</dd>
																</> : ""}</>

																: ""}

														</div> : ""}
												</dl>
											</div>
										</div>

									</div>
								</div>
							</section>
							: ""}
						{/* {productTypeRef.current?
							<iframe width="100%" height="800px" className='d-none' src={`${window.location.protocol}//${window.location.hostname}/bazaarVoice?prodType=${productTypeRef.current && productTypeRef.current}`} /> : ""}  */}
						<ReviewSection productId={containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.familyProductId ? containerObject.atgResponse.response.response.familyVariyantProductDetails.familyProductId : prodIdRef.current} dlProduct={isDlproductRef.current} ></ReviewSection>
						<Question productId={containerObject?.atgResponse?.response?.response?.familyVariyantProductDetails?.familyProductId ? containerObject.atgResponse.response.response.familyVariyantProductDetails.familyProductId : prodIdRef.current} dlProduct={isDlproductRef.current} prodType={productTypeRef.current} />

					</div>

						{/* recommended accessories */}
						<RecommendedAccessories containerObject={containerObject} quickviewCallback={handleQuickView} solrValue={handleQuickViewCount} />

						{/* You may also Like */}
						{siteSpecDetailsRef.current && isDlproductRef.current == false ? <YouMayAlso siteSpec={siteSpecDetailsRef.current} domainName={containerObject.domainName} quickviewCallback={handleQuickView} /> : ""}

						{/* need help */}
						{isDlproductRef.current == false ? "" :
							<div className="pdp-detail-info border-0 pdp-detail-moreinfo">

								<div className="c-container dl-need-help" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdp_dl_product_help }}>

								</div>
							</div>}
					</>}
			</div >
		</> : ""
		}
	</>);
}
export default ProductDetailsContainer;